// Auto-generated AllPHPComponents.js

import PHP from "./components/PHP";
import PHP_AbstractClasses from "./components/PHP_AbstractClasses";
import PHP_AccessModifiers from "./components/PHP_AccessModifiers";
import PHP_Access_Array_Items from "./components/PHP_Access_Array_Items";
import PHP_Add_Array_Items from "./components/PHP_Add_Array_Items";
import PHP_AjaxDatabase from "./components/PHP_AjaxDatabase";
import PHP_AjaxIntro from "./components/PHP_AjaxIntro";
import PHP_AjaxLiveSearch from "./components/PHP_AjaxLiveSearch";
import PHP_AjaxPHP from "./components/PHP_AjaxPHP";
import PHP_AjaxPoll from "./components/PHP_AjaxPoll";
import PHP_AjaxXML from "./components/PHP_AjaxXML";
import PHP_Array_Functions from "./components/PHP_Array_Functions";
import PHP_Arrays from "./components/PHP_Arrays";
import PHP_Associative_Arrays from "./components/PHP_Associative_Arrays";

import PHP_Calendar from "./components/PHP_Calendar";
import PHP_CallbackFunctions from "./components/PHP_CallbackFunctions";
import PHP_Casting from "./components/PHP_Casting";
import PHP_Certificate from "./components/PHP_Certificate";
import PHP_ClassesObjects from "./components/PHP_ClassesObjects";
import PHP_Comments from "./components/PHP_Comments";
import PHP_Compiler from "./components/PHP_Compiler";
import PHP_Concatenate_Strings from "./components/PHP_Concatenate_Strings";
import PHP_Constants from "./components/PHP_Constants";
import PHP_Constructor from "./components/PHP_Constructor";

import PHP_Cookies from "./components/PHP_Cookies";
import PHP_Create_Arrays from "./components/PHP_Create_Arrays";
import PHP_DataTypes from "./components/PHP_DataTypes";
import PHP_DateTime from "./components/PHP_DateTime";
import PHP_Destructor from "./components/PHP_Destructor";
import PHP_Do_While_Loop from "./components/PHP_Do_While_Loop";
import PHP_EchoPrint from "./components/PHP_EchoPrint";
import PHP_Escape_Characters from "./components/PHP_Escape_Characters";
import PHP_Examples from "./components/PHP_Examples";
import PHP_Exception from "./components/PHP_Exception";
import PHP_Exception_Main from "./components/PHP_Exception_Main";
import PHP_Exceptions from "./components/PHP_Exceptions";
import PHP_Exercises from "./components/PHP_Exercises";
import PHP_FileCreateWrite from "./components/PHP_FileCreateWrite";
import PHP_FileHandling from "./components/PHP_FileHandling";
import PHP_FileOpenRead from "./components/PHP_FileOpenRead";
import PHP_FileUpload from "./components/PHP_FileUpload";
import PHP_Filters from "./components/PHP_Filters";
import PHP_FiltersAdvanced from "./components/PHP_FiltersAdvanced";
import PHP_For_Loop from "./components/PHP_For_Loop";
import PHP_Foreach_Loop from "./components/PHP_Foreach_Loop";
import PHP_FormComplete from "./components/PHP_FormComplete";
import PHP_FormHandling from "./components/PHP_FormHandling";
import PHP_FormRequired from "./components/PHP_FormRequired";
import PHP_FormUrlEmail from "./components/PHP_FormUrlEmail";
import PHP_FormValidation from "./components/PHP_FormValidation";
import PHP_Functions from "./components/PHP_Functions";
import PHP_GET from "./components/PHP_GET";
import PHP_GLOBALS from "./components/PHP_GLOBALS";
import PHP_HOME from "./components/PHP_HOME";
import PHP_If from "./components/PHP_If";
import PHP_IfElse_Main from "./components/PHP_IfElse_Main";
import PHP_If_Operators from "./components/PHP_If_Operators";
import PHP_Include from "./components/PHP_Include";
import PHP_Indexed_Arrays from "./components/PHP_Indexed_Arrays";
import PHP_Inheritance from "./components/PHP_Inheritance";
import PHP_Install from "./components/PHP_Install";
import PHP_Interfaces from "./components/PHP_Interfaces";
import PHP_Intro from "./components/PHP_Intro";
import PHP_Iterables from "./components/PHP_Iterables";
import PHP_JSON from "./components/PHP_JSON";
import PHP_Loops from "./components/PHP_Loops";
import PHP_MagicConstants from "./components/PHP_MagicConstants";
import PHP_Math from "./components/PHP_Math";
import PHP_Modify_Strings from "./components/PHP_Modify_Strings";
import PHP_Multidimensional_Arrays from "./components/PHP_Multidimensional_Arrays";
import PHP_Multiline_Comments from "./components/PHP_Multiline_Comments";
import PHP_MySQLConnect from "./components/PHP_MySQLConnect";
import PHP_MySQLCreateDB from "./components/PHP_MySQLCreateDB";
import PHP_MySQLCreateTable from "./components/PHP_MySQLCreateTable";
import PHP_MySQLDatabase from "./components/PHP_MySQLDatabase";
import PHP_MySQLDelete from "./components/PHP_MySQLDelete";
import PHP_MySQLInsert from "./components/PHP_MySQLInsert";
import PHP_MySQLInsertMultiple from "./components/PHP_MySQLInsertMultiple";
import PHP_MySQLLastID from "./components/PHP_MySQLLastID";
import PHP_MySQLLimit from "./components/PHP_MySQLLimit";
import PHP_MySQLOrderBy from "./components/PHP_MySQLOrderBy";
import PHP_MySQLPrepared from "./components/PHP_MySQLPrepared";
import PHP_MySQLSelect from "./components/PHP_MySQLSelect";
import PHP_MySQLUpdate from "./components/PHP_MySQLUpdate";
import PHP_MySQLWhere from "./components/PHP_MySQLWhere";
import PHP_Namespaces from "./components/PHP_Namespaces";
import PHP_Nested_If from "./components/PHP_Nested_If";
import PHP_Numbers from "./components/PHP_Numbers";
import PHP_OOPConstants from "./components/PHP_OOPConstants";
import PHP_OOPIntro from "./components/PHP_OOPIntro";
import PHP_Operators from "./components/PHP_Operators";
import PHP_POST from "./components/PHP_POST";
import PHP_Quiz from "./components/PHP_Quiz";
import PHP_REQUEST from "./components/PHP_REQUEST";
import PHP_RefArray from "./components/PHP_RefArray";
import PHP_ReferenceArray from "./components/PHP_ReferenceArray";
import PHP_ReferenceFTP from "./components/PHP_ReferenceFTP";
import PHP_ReferenceFilesystem from "./components/PHP_ReferenceFilesystem";
import PHP_ReferenceFilter from "./components/PHP_ReferenceFilter";
import PHP_ReferenceJSON from "./components/PHP_ReferenceJSON";
import PHP_ReferenceKeywords from "./components/PHP_ReferenceKeywords";
import PHP_ReferenceLibxml from "./components/PHP_ReferenceLibxml";
import PHP_ReferenceMail from "./components/PHP_ReferenceMail";
import PHP_ReferenceMath from "./components/PHP_ReferenceMath";
import PHP_ReferenceMisc from "./components/PHP_ReferenceMisc";
import PHP_ReferenceMySQLi from "./components/PHP_ReferenceMySQLi";
import PHP_ReferenceNetwork from "./components/PHP_ReferenceNetwork";
import PHP_ReferenceOutputControl from "./components/PHP_ReferenceOutputControl";
import PHP_ReferenceOverview from "./components/PHP_ReferenceOverview";
import PHP_ReferenceRegEx from "./components/PHP_ReferenceRegEx";
import PHP_ReferenceSimpleXML from "./components/PHP_ReferenceSimpleXML";
import PHP_ReferenceStream from "./components/PHP_ReferenceStream";
import PHP_ReferenceString from "./components/PHP_ReferenceString";
import PHP_ReferenceTimezones from "./components/PHP_ReferenceTimezones";
import PHP_ReferenceVariableHandling from "./components/PHP_ReferenceVariableHandling";
import PHP_ReferenceXMLParser from "./components/PHP_ReferenceXMLParser";
import PHP_ReferenceZip from "./components/PHP_ReferenceZip";
import PHP_RegEx from "./components/PHP_RegEx";
import PHP_Remove_Array_Items from "./components/PHP_Remove_Array_Items";

import PHP_Sessions from "./components/PHP_Sessions";
import PHP_Shorthand_If from "./components/PHP_Shorthand_If";
import PHP_SimpleXMLGet from "./components/PHP_SimpleXMLGet";
import PHP_SimpleXMLParser from "./components/PHP_SimpleXMLParser";
import PHP_Slicing_Strings from "./components/PHP_Slicing_Strings";
import PHP_Sorting_Arrays from "./components/PHP_Sorting_Arrays";
import PHP_StaticMethods from "./components/PHP_StaticMethods";
import PHP_StaticProperties from "./components/PHP_StaticProperties";
import PHP_Strings from "./components/PHP_Strings";
import PHP_StudyPlan from "./components/PHP_StudyPlan";
import PHP_Superglobals from "./components/PHP_Superglobals";
import PHP_Switch from "./components/PHP_Switch";
import PHP_Syllabus from "./components/PHP_Syllabus";
import PHP_Syntax from "./components/PHP_Syntax";
import PHP_Traits from "./components/PHP_Traits";
import PHP_Update_Array_Items from "./components/PHP_Update_Array_Items";
import PHP_Variables from "./components/PHP_Variables";
import PHP_Variables_Main from "./components/PHP_Variables_Main";
import PHP_Variables_Scope from "./components/PHP_Variables_Scope";
import PHP_While_Loop from "./components/PHP_While_Loop";
import PHP_XMLDOM from "./components/PHP_XMLDOM";
import PHP_XMLExpat from "./components/PHP_XMLExpat";
import PHP_XMLParsers from "./components/PHP_XMLParsers";
import PHP___construct from "./components/PHP___construct";
import PHP___halt_compiler from "./components/PHP___halt_compiler";
import PHP___tostring from "./components/PHP___tostring";
import PHP_abs from "./components/PHP_abs";
import PHP_abstract from "./components/PHP_abstract";
import PHP_acos from "./components/PHP_acos";
import PHP_acosh from "./components/PHP_acosh";
import PHP_addAttribute from "./components/PHP_addAttribute";
import PHP_addChild from "./components/PHP_addChild";
import PHP_addcslashes from "./components/PHP_addcslashes";
import PHP_addslashes from "./components/PHP_addslashes";
import PHP_affected_rows from "./components/PHP_affected_rows";
import PHP_and from "./components/PHP_and";
import PHP_array_change_key_case from "./components/PHP_array_change_key_case";
import PHP_array_chunk from "./components/PHP_array_chunk";
import PHP_array_column from "./components/PHP_array_column";
import PHP_array_combine from "./components/PHP_array_combine";
import PHP_array_count_values from "./components/PHP_array_count_values";
import PHP_array_diff from "./components/PHP_array_diff";
import PHP_array_diff_assoc from "./components/PHP_array_diff_assoc";
import PHP_array_diff_key from "./components/PHP_array_diff_key";
import PHP_array_diff_uassoc from "./components/PHP_array_diff_uassoc";
import PHP_array_diff_ukey from "./components/PHP_array_diff_ukey";
import PHP_array_fill from "./components/PHP_array_fill";
import PHP_array_fill_keys from "./components/PHP_array_fill_keys";
import PHP_array_filter from "./components/PHP_array_filter";
import PHP_array_flip from "./components/PHP_array_flip";
import PHP_array_intersect from "./components/PHP_array_intersect";
import PHP_array_intersect_assoc from "./components/PHP_array_intersect_assoc";
import PHP_array_intersect_key from "./components/PHP_array_intersect_key";
import PHP_array_intersect_uassoc from "./components/PHP_array_intersect_uassoc";
import PHP_array_intersect_ukey from "./components/PHP_array_intersect_ukey";
import PHP_array_key_exists from "./components/PHP_array_key_exists";
import PHP_array_keys from "./components/PHP_array_keys";
import PHP_array_map from "./components/PHP_array_map";
import PHP_array_merge from "./components/PHP_array_merge";
import PHP_array_merge_recursive from "./components/PHP_array_merge_recursive";
import PHP_array_multisort from "./components/PHP_array_multisort";
import PHP_array_pad from "./components/PHP_array_pad";
import PHP_array_pop from "./components/PHP_array_pop";
import PHP_array_product from "./components/PHP_array_product";
import PHP_array_push from "./components/PHP_array_push";
import PHP_array_rand from "./components/PHP_array_rand";
import PHP_array_reduce from "./components/PHP_array_reduce";
import PHP_array_replace from "./components/PHP_array_replace";
import PHP_array_replace_recursive from "./components/PHP_array_replace_recursive";
import PHP_array_reverse from "./components/PHP_array_reverse";
import PHP_array_search from "./components/PHP_array_search";
import PHP_array_shift from "./components/PHP_array_shift";
import PHP_array_slice from "./components/PHP_array_slice";
import PHP_array_splice from "./components/PHP_array_splice";
import PHP_array_sum from "./components/PHP_array_sum";
import PHP_array_udiff from "./components/PHP_array_udiff";
import PHP_array_udiff_assoc from "./components/PHP_array_udiff_assoc";
import PHP_array_udiff_uassoc from "./components/PHP_array_udiff_uassoc";
import PHP_array_uintersect from "./components/PHP_array_uintersect";
import PHP_array_uintersect_assoc from "./components/PHP_array_uintersect_assoc";
import PHP_array_uintersect_uassoc from "./components/PHP_array_uintersect_uassoc";
import PHP_array_unique from "./components/PHP_array_unique";
import PHP_array_unshift from "./components/PHP_array_unshift";
import PHP_array_values from "./components/PHP_array_values";
import PHP_array_walk from "./components/PHP_array_walk";
import PHP_array_walk_recursive from "./components/PHP_array_walk_recursive";
import PHP_arsort from "./components/PHP_arsort";
import PHP_as from "./components/PHP_as";
import PHP_asXML from "./components/PHP_asXML";
import PHP_asin from "./components/PHP_asin";
import PHP_asinh from "./components/PHP_asinh";
import PHP_asort from "./components/PHP_asort";
import PHP_atan from "./components/PHP_atan";
import PHP_atan2 from "./components/PHP_atan2";
import PHP_atanh from "./components/PHP_atanh";
import PHP_attributes from "./components/PHP_attributes";
import PHP_autocommit from "./components/PHP_autocommit";
import PHP_base_convert from "./components/PHP_base_convert";
import PHP_basename from "./components/PHP_basename";
import PHP_bin2hex from "./components/PHP_bin2hex";
import PHP_bindec from "./components/PHP_bindec";
import PHP_boolval from "./components/PHP_boolval";

import PHP_cal_days_in_month from "./components/PHP_cal_days_in_month";
import PHP_cal_from_jd from "./components/PHP_cal_from_jd";
import PHP_cal_info from "./components/PHP_cal_info";
import PHP_cal_to_jd from "./components/PHP_cal_to_jd";
import PHP_callable from "./components/PHP_callable";
import PHP_case from "./components/PHP_case";
import PHP_catch from "./components/PHP_catch";
import PHP_ceil from "./components/PHP_ceil";
import PHP_change_user from "./components/PHP_change_user";
import PHP_character_set_name from "./components/PHP_character_set_name";
import PHP_chdir from "./components/PHP_chdir";
import PHP_checkdate from "./components/PHP_checkdate";
import PHP_checkdnsrr from "./components/PHP_checkdnsrr";
import PHP_chgrp from "./components/PHP_chgrp";
import PHP_children from "./components/PHP_children";
import PHP_chmod from "./components/PHP_chmod";
import PHP_chop from "./components/PHP_chop";
import PHP_chown from "./components/PHP_chown";
import PHP_chr from "./components/PHP_chr";
import PHP_chroot from "./components/PHP_chroot";
import PHP_chunk_split from "./components/PHP_chunk_split";
import PHP_class from "./components/PHP_class";
import PHP_clearstatcache from "./components/PHP_clearstatcache";
import PHP_clone from "./components/PHP_clone";
import PHP_close from "./components/PHP_close";
import PHP_closedir from "./components/PHP_closedir";
import PHP_closelog from "./components/PHP_closelog";
import PHP_commit from "./components/PHP_commit";
import PHP_compact from "./components/PHP_compact";
import PHP_connect from "./components/PHP_connect";
import PHP_connect_errno from "./components/PHP_connect_errno";
import PHP_connect_error from "./components/PHP_connect_error";
import PHP_connection_aborted from "./components/PHP_connection_aborted";
import PHP_connection_status from "./components/PHP_connection_status";
import PHP_connection_timeout from "./components/PHP_connection_timeout";
import PHP_const from "./components/PHP_const";
import PHP_constant from "./components/PHP_constant";

import PHP_convert_cyr_string from "./components/PHP_convert_cyr_string";
import PHP_convert_uudecode from "./components/PHP_convert_uudecode";
import PHP_convert_uuencode from "./components/PHP_convert_uuencode";
import PHP_copy from "./components/PHP_copy";
import PHP_cos from "./components/PHP_cos";
import PHP_cosh from "./components/PHP_cosh";
import PHP_count from "./components/PHP_count";
import PHP_count_chars from "./components/PHP_count_chars";
import PHP_crc32 from "./components/PHP_crc32";
import PHP_crypt from "./components/PHP_crypt";
import PHP_current from "./components/PHP_current";
import PHP_data_seek from "./components/PHP_data_seek";
import PHP_date from "./components/PHP_date";
import PHP_date_add from "./components/PHP_date_add";
import PHP_date_create from "./components/PHP_date_create";
import PHP_date_create_from_format from "./components/PHP_date_create_from_format";
import PHP_date_date_set from "./components/PHP_date_date_set";
import PHP_date_default_timezone_get from "./components/PHP_date_default_timezone_get";
import PHP_date_default_timezone_set from "./components/PHP_date_default_timezone_set";
import PHP_date_diff from "./components/PHP_date_diff";
import PHP_date_format from "./components/PHP_date_format";
import PHP_date_get_last_errors from "./components/PHP_date_get_last_errors";
import PHP_date_interval_create_from_date_string from "./components/PHP_date_interval_create_from_date_string";
import PHP_date_interval_format from "./components/PHP_date_interval_format";
import PHP_date_isodate_set from "./components/PHP_date_isodate_set";
import PHP_date_modify from "./components/PHP_date_modify";
import PHP_date_offset_get from "./components/PHP_date_offset_get";
import PHP_date_parse from "./components/PHP_date_parse";
import PHP_date_parse_from_format from "./components/PHP_date_parse_from_format";
import PHP_date_sub from "./components/PHP_date_sub";
import PHP_date_sun_info from "./components/PHP_date_sun_info";
import PHP_date_sunrise from "./components/PHP_date_sunrise";
import PHP_date_sunset from "./components/PHP_date_sunset";
import PHP_date_time_set from "./components/PHP_date_time_set";
import PHP_date_timestamp_get from "./components/PHP_date_timestamp_get";
import PHP_date_timestamp_set from "./components/PHP_date_timestamp_set";
import PHP_date_timezone_get from "./components/PHP_date_timezone_get";
import PHP_date_timezone_set from "./components/PHP_date_timezone_set";
import PHP_debug from "./components/PHP_debug";
import PHP_debug_backtrace from "./components/PHP_debug_backtrace";
import PHP_debug_print_backtrace from "./components/PHP_debug_print_backtrace";
import PHP_debug_zval_dump from "./components/PHP_debug_zval_dump";
import PHP_decbin from "./components/PHP_decbin";
import PHP_dechex from "./components/PHP_dechex";
import PHP_declare from "./components/PHP_declare";
import PHP_decoct from "./components/PHP_decoct";
import PHP_default from "./components/PHP_default";
import PHP_define from "./components/PHP_define";
import PHP_defined from "./components/PHP_defined";
import PHP_deg2rad from "./components/PHP_deg2rad";
import PHP_delete from "./components/PHP_delete";
import PHP_die from "./components/PHP_die";
import PHP_dir from "./components/PHP_dir";
import PHP_dirname from "./components/PHP_dirname";
import PHP_disk_free_space from "./components/PHP_disk_free_space";
import PHP_disk_total_space from "./components/PHP_disk_total_space";
import PHP_diskfreespace from "./components/PHP_diskfreespace";
import PHP_dns_check_record from "./components/PHP_dns_check_record";
import PHP_dns_get_mx from "./components/PHP_dns_get_mx";
import PHP_dns_get_record from "./components/PHP_dns_get_record";
import PHP_do from "./components/PHP_do";
import PHP_doubleval from "./components/PHP_doubleval";
import PHP_dump_debug_info from "./components/PHP_dump_debug_info";
import PHP_each from "./components/PHP_each";
import PHP_easter_date from "./components/PHP_easter_date";
import PHP_easter_days from "./components/PHP_easter_days";
import PHP_echo from "./components/PHP_echo";
import PHP_else from "./components/PHP_else";
import PHP_elseif from "./components/PHP_elseif";
import PHP_empty from "./components/PHP_empty";
import PHP_end from "./components/PHP_end";
import PHP_enddeclare from "./components/PHP_enddeclare";
import PHP_endfor from "./components/PHP_endfor";
import PHP_endforeach from "./components/PHP_endforeach";
import PHP_endif from "./components/PHP_endif";
import PHP_endswitch from "./components/PHP_endswitch";
import PHP_endwhile from "./components/PHP_endwhile";
import PHP_errno from "./components/PHP_errno";
import PHP_error from "./components/PHP_error";
import PHP_error_get_last from "./components/PHP_error_get_last";
import PHP_error_list from "./components/PHP_error_list";
import PHP_error_log from "./components/PHP_error_log";
import PHP_error_reporting from "./components/PHP_error_reporting";
import PHP_eval from "./components/PHP_eval";
import PHP_exit from "./components/PHP_exit";
import PHP_exp from "./components/PHP_exp";
import PHP_explode from "./components/PHP_explode";
import PHP_expm1 from "./components/PHP_expm1";
import PHP_extends from "./components/PHP_extends";
import PHP_extract from "./components/PHP_extract";
import PHP_ezmlm_hash from "./components/PHP_ezmlm_hash";
import PHP_fclose from "./components/PHP_fclose";
import PHP_feof from "./components/PHP_feof";
import PHP_fetch_all from "./components/PHP_fetch_all";
import PHP_fetch_array from "./components/PHP_fetch_array";
import PHP_fetch_assoc from "./components/PHP_fetch_assoc";
import PHP_fetch_field from "./components/PHP_fetch_field";
import PHP_fetch_field_direct from "./components/PHP_fetch_field_direct";
import PHP_fetch_fields from "./components/PHP_fetch_fields";
import PHP_fetch_lengths from "./components/PHP_fetch_lengths";
import PHP_fetch_object from "./components/PHP_fetch_object";
import PHP_fetch_row from "./components/PHP_fetch_row";
import PHP_fflush from "./components/PHP_fflush";
import PHP_fgetc from "./components/PHP_fgetc";
import PHP_fgetcsv from "./components/PHP_fgetcsv";
import PHP_fgets from "./components/PHP_fgets";
import PHP_fgetss from "./components/PHP_fgetss";
import PHP_field_count from "./components/PHP_field_count";
import PHP_field_seek from "./components/PHP_field_seek";
import PHP_file from "./components/PHP_file";
import PHP_file_exists from "./components/PHP_file_exists";
import PHP_file_get_contents from "./components/PHP_file_get_contents";
import PHP_file_put_contents from "./components/PHP_file_put_contents";
import PHP_fileatime from "./components/PHP_fileatime";
import PHP_filectime from "./components/PHP_filectime";
import PHP_filegroup from "./components/PHP_filegroup";
import PHP_fileinode from "./components/PHP_fileinode";
import PHP_filemtime from "./components/PHP_filemtime";
import PHP_fileowner from "./components/PHP_fileowner";
import PHP_fileperms from "./components/PHP_fileperms";
import PHP_filesize from "./components/PHP_filesize";
import PHP_filetype from "./components/PHP_filetype";
import PHP_filter_has_var from "./components/PHP_filter_has_var";
import PHP_filter_id from "./components/PHP_filter_id";
import PHP_filter_input from "./components/PHP_filter_input";
import PHP_filter_input_array from "./components/PHP_filter_input_array";
import PHP_filter_list from "./components/PHP_filter_list";
import PHP_filter_var from "./components/PHP_filter_var";
import PHP_filter_var_array from "./components/PHP_filter_var_array";
import PHP_final from "./components/PHP_final";
import PHP_finally from "./components/PHP_finally";
import PHP_floatval from "./components/PHP_floatval";
import PHP_flock from "./components/PHP_flock";
import PHP_floor from "./components/PHP_floor";
import PHP_flush from "./components/PHP_flush";
import PHP_fmod from "./components/PHP_fmod";
import PHP_fn from "./components/PHP_fn";
import PHP_fnmatch from "./components/PHP_fnmatch";
import PHP_fopen from "./components/PHP_fopen";
import PHP_for from "./components/PHP_for";
import PHP_foreach from "./components/PHP_foreach";
import PHP_fpassthru from "./components/PHP_fpassthru";
import PHP_fprint from "./components/PHP_fprint";
import PHP_fputcsv from "./components/PHP_fputcsv";
import PHP_fputs from "./components/PHP_fputs";
import PHP_fread from "./components/PHP_fread";
import PHP_frenchtojd from "./components/PHP_frenchtojd";
import PHP_fscanf from "./components/PHP_fscanf";
import PHP_fseek from "./components/PHP_fseek";
import PHP_fsockopen from "./components/PHP_fsockopen";
import PHP_fstat from "./components/PHP_fstat";
import PHP_ftell from "./components/PHP_ftell";
import PHP_ftp_alloc from "./components/PHP_ftp_alloc";
import PHP_ftp_cdup from "./components/PHP_ftp_cdup";
import PHP_ftp_chdir from "./components/PHP_ftp_chdir";
import PHP_ftp_chmod from "./components/PHP_ftp_chmod";
import PHP_ftp_close from "./components/PHP_ftp_close";
import PHP_ftp_connect from "./components/PHP_ftp_connect";
import PHP_ftp_delete from "./components/PHP_ftp_delete";
import PHP_ftp_exec from "./components/PHP_ftp_exec";
import PHP_ftp_fget from "./components/PHP_ftp_fget";
import PHP_ftp_fput from "./components/PHP_ftp_fput";
import PHP_ftp_get from "./components/PHP_ftp_get";
import PHP_ftp_get_option from "./components/PHP_ftp_get_option";
import PHP_ftp_login from "./components/PHP_ftp_login";
import PHP_ftp_mdtm from "./components/PHP_ftp_mdtm";
import PHP_ftp_mkdir from "./components/PHP_ftp_mkdir";
import PHP_ftp_mlsd from "./components/PHP_ftp_mlsd";
import PHP_ftp_nb_continue from "./components/PHP_ftp_nb_continue";
import PHP_ftp_nb_fget from "./components/PHP_ftp_nb_fget";
import PHP_ftp_nb_fput from "./components/PHP_ftp_nb_fput";
import PHP_ftp_nb_get from "./components/PHP_ftp_nb_get";
import PHP_ftp_nb_put from "./components/PHP_ftp_nb_put";
import PHP_ftp_nlist from "./components/PHP_ftp_nlist";
import PHP_ftp_pasv from "./components/PHP_ftp_pasv";
import PHP_ftp_put from "./components/PHP_ftp_put";
import PHP_ftp_pwd from "./components/PHP_ftp_pwd";
import PHP_ftp_quit from "./components/PHP_ftp_quit";
import PHP_ftp_raw from "./components/PHP_ftp_raw";
import PHP_ftp_rawlist from "./components/PHP_ftp_rawlist";
import PHP_ftp_rename from "./components/PHP_ftp_rename";
import PHP_ftp_rmdir from "./components/PHP_ftp_rmdir";
import PHP_ftp_set_option from "./components/PHP_ftp_set_option";
import PHP_ftp_site from "./components/PHP_ftp_site";
import PHP_ftp_size from "./components/PHP_ftp_size";
import PHP_ftp_ssl_connect from "./components/PHP_ftp_ssl_connect";
import PHP_ftp_systype from "./components/PHP_ftp_systype";
import PHP_ftruncate from "./components/PHP_ftruncate";
import PHP_function from "./components/PHP_function";
import PHP_fwrite from "./components/PHP_fwrite";
import PHP_getCode from "./components/PHP_getCode";
import PHP_getDocNamespaces from "./components/PHP_getDocNamespaces";
import PHP_getFile from "./components/PHP_getFile";
import PHP_getLine from "./components/PHP_getLine";
import PHP_getMessage from "./components/PHP_getMessage";
import PHP_getName from "./components/PHP_getName";
import PHP_getNamespaces from "./components/PHP_getNamespaces";
import PHP_getPrevious from "./components/PHP_getPrevious";
import PHP_getTrace from "./components/PHP_getTrace";
import PHP_getTraceAsString from "./components/PHP_getTraceAsString";
import PHP_get_browser from "./components/PHP_get_browser";
import PHP_get_charset from "./components/PHP_get_charset";
import PHP_get_client_info from "./components/PHP_get_client_info";
import PHP_get_client_stats from "./components/PHP_get_client_stats";
import PHP_get_client_version from "./components/PHP_get_client_version";
import PHP_get_connection_stats from "./components/PHP_get_connection_stats";
import PHP_get_defined_vars from "./components/PHP_get_defined_vars";
import PHP_get_host_info from "./components/PHP_get_host_info";
import PHP_get_html_translation_table from "./components/PHP_get_html_translation_table";
import PHP_get_proto_info from "./components/PHP_get_proto_info";
import PHP_get_resource_type from "./components/PHP_get_resource_type";
import PHP_get_server_info from "./components/PHP_get_server_info";
import PHP_get_server_version from "./components/PHP_get_server_version";
import PHP_getchildren from "./components/PHP_getchildren";
import PHP_getcwd from "./components/PHP_getcwd";
import PHP_getdate from "./components/PHP_getdate";
import PHP_gethostbyaddr from "./components/PHP_gethostbyaddr";
import PHP_gethostbyname from "./components/PHP_gethostbyname";
import PHP_gethostbynamel from "./components/PHP_gethostbynamel";
import PHP_gethostname from "./components/PHP_gethostname";
import PHP_getmxrr from "./components/PHP_getmxrr";
import PHP_getprotobyname from "./components/PHP_getprotobyname";
import PHP_getprotobynumber from "./components/PHP_getprotobynumber";
import PHP_getrandmax from "./components/PHP_getrandmax";
import PHP_getservbyname from "./components/PHP_getservbyname";
import PHP_getservbyport from "./components/PHP_getservbyport";
import PHP_gettimeofday from "./components/PHP_gettimeofday";
import PHP_gettype from "./components/PHP_gettype";
import PHP_glob from "./components/PHP_glob";
import PHP_global from "./components/PHP_global";
import PHP_gmdate from "./components/PHP_gmdate";
import PHP_gmmktime from "./components/PHP_gmmktime";
import PHP_gmstrftime from "./components/PHP_gmstrftime";
import PHP_gregoriantojd from "./components/PHP_gregoriantojd";
import PHP_haschildren from "./components/PHP_haschildren";
import PHP_header from "./components/PHP_header";
import PHP_header_register_callback from "./components/PHP_header_register_callback";
import PHP_header_remove from "./components/PHP_header_remove";
import PHP_headers_list from "./components/PHP_headers_list";
import PHP_headers_sent from "./components/PHP_headers_sent";
import PHP_hebrev from "./components/PHP_hebrev";
import PHP_hebrevc from "./components/PHP_hebrevc";
import PHP_hex2bin from "./components/PHP_hex2bin";
import PHP_hexdec from "./components/PHP_hexdec";
import PHP_highlight_file from "./components/PHP_highlight_file";
import PHP_highlight_string from "./components/PHP_highlight_string";
import PHP_hrtime from "./components/PHP_hrtime";
import PHP_html_entity_decode from "./components/PHP_html_entity_decode";
import PHP_htmlentities from "./components/PHP_htmlentities";
import PHP_htmlspecialchars from "./components/PHP_htmlspecialchars";
import PHP_htmlspecialchars_decode from "./components/PHP_htmlspecialchars_decode";
import PHP_http_response_code from "./components/PHP_http_response_code";
import PHP_hypot from "./components/PHP_hypot";
import PHP_idate from "./components/PHP_idate";

import PHP_ignore_user_abort from "./components/PHP_ignore_user_abort";
import PHP_implements from "./components/PHP_implements";
import PHP_implode from "./components/PHP_implode";
import PHP_in_array from "./components/PHP_in_array";

import PHP_include_once from "./components/PHP_include_once";
import PHP_inet_ntop from "./components/PHP_inet_ntop";
import PHP_inet_pton from "./components/PHP_inet_pton";
import PHP_info from "./components/PHP_info";
import PHP_init from "./components/PHP_init";
import PHP_insert_id from "./components/PHP_insert_id";
import PHP_instanceof from "./components/PHP_instanceof";
import PHP_insteadof from "./components/PHP_insteadof";
import PHP_intdiv from "./components/PHP_intdiv";
import PHP_interface from "./components/PHP_interface";
import PHP_intval from "./components/PHP_intval";
import PHP_ip2long from "./components/PHP_ip2long";
import PHP_is_array from "./components/PHP_is_array";
import PHP_is_bool from "./components/PHP_is_bool";
import PHP_is_callable from "./components/PHP_is_callable";
import PHP_is_countable from "./components/PHP_is_countable";
import PHP_is_dir from "./components/PHP_is_dir";
import PHP_is_double from "./components/PHP_is_double";
import PHP_is_executable from "./components/PHP_is_executable";
import PHP_is_file from "./components/PHP_is_file";
import PHP_is_finite from "./components/PHP_is_finite";
import PHP_is_float from "./components/PHP_is_float";
import PHP_is_infinite from "./components/PHP_is_infinite";
import PHP_is_int from "./components/PHP_is_int";
import PHP_is_integer from "./components/PHP_is_integer";
import PHP_is_iterable from "./components/PHP_is_iterable";
import PHP_is_link from "./components/PHP_is_link";
import PHP_is_long from "./components/PHP_is_long";
import PHP_is_nan from "./components/PHP_is_nan";
import PHP_is_null from "./components/PHP_is_null";
import PHP_is_numeric from "./components/PHP_is_numeric";
import PHP_is_object from "./components/PHP_is_object";
import PHP_is_readable from "./components/PHP_is_readable";
import PHP_is_real from "./components/PHP_is_real";
import PHP_is_resource from "./components/PHP_is_resource";
import PHP_is_scalar from "./components/PHP_is_scalar";
import PHP_is_string from "./components/PHP_is_string";
import PHP_is_uploaded_file from "./components/PHP_is_uploaded_file";
import PHP_is_writable from "./components/PHP_is_writable";
import PHP_is_writeable from "./components/PHP_is_writeable";
import PHP_isset from "./components/PHP_isset";
import PHP_jddayofweek from "./components/PHP_jddayofweek";
import PHP_jdmonthname from "./components/PHP_jdmonthname";
import PHP_jdtofrench from "./components/PHP_jdtofrench";
import PHP_jdtogregorian from "./components/PHP_jdtogregorian";
import PHP_jdtojewish from "./components/PHP_jdtojewish";
import PHP_jdtojulian from "./components/PHP_jdtojulian";
import PHP_jdtounix from "./components/PHP_jdtounix";
import PHP_jewishtojd from "./components/PHP_jewishtojd";
import PHP_join from "./components/PHP_join";
import PHP_json_decode from "./components/PHP_json_decode";
import PHP_json_encode from "./components/PHP_json_encode";
import PHP_juliantojd from "./components/PHP_juliantojd";
import PHP_key from "./components/PHP_key";
import PHP_kill from "./components/PHP_kill";
import PHP_krsort from "./components/PHP_krsort";
import PHP_ksort from "./components/PHP_ksort";
import PHP_lcfirst from "./components/PHP_lcfirst";
import PHP_lcg_value from "./components/PHP_lcg_value";
import PHP_lchgrp from "./components/PHP_lchgrp";
import PHP_lchown from "./components/PHP_lchown";
import PHP_levenshtein from "./components/PHP_levenshtein";
import PHP_libxml_clear_errors from "./components/PHP_libxml_clear_errors";
import PHP_libxml_disable_entity_loader from "./components/PHP_libxml_disable_entity_loader";
import PHP_libxml_get_errors from "./components/PHP_libxml_get_errors";
import PHP_libxml_get_last_error from "./components/PHP_libxml_get_last_error";
import PHP_libxml_set_external_entity_loader from "./components/PHP_libxml_set_external_entity_loader";
import PHP_libxml_set_streams_context from "./components/PHP_libxml_set_streams_context";
import PHP_libxml_use_internal_errors from "./components/PHP_libxml_use_internal_errors";
import PHP_link from "./components/PHP_link";
import PHP_linkinfo from "./components/PHP_linkinfo";
import PHP_list from "./components/PHP_list";
import PHP_localeconv from "./components/PHP_localeconv";
import PHP_localtime from "./components/PHP_localtime";
import PHP_log from "./components/PHP_log";
import PHP_log10 from "./components/PHP_log10";
import PHP_log1p from "./components/PHP_log1p";
import PHP_long2ip from "./components/PHP_long2ip";
import PHP_lstat from "./components/PHP_lstat";
import PHP_ltrim from "./components/PHP_ltrim";
import PHP_mail from "./components/PHP_mail";
import PHP_max from "./components/PHP_max";
import PHP_md5 from "./components/PHP_md5";
import PHP_md5_file from "./components/PHP_md5_file";
import PHP_metaphone from "./components/PHP_metaphone";
import PHP_microtime from "./components/PHP_microtime";
import PHP_min from "./components/PHP_min";
import PHP_mkdir from "./components/PHP_mkdir";
import PHP_mktime from "./components/PHP_mktime";
import PHP_money_format from "./components/PHP_money_format";
import PHP_more_results from "./components/PHP_more_results";
import PHP_move_uploaded_file from "./components/PHP_move_uploaded_file";
import PHP_mt_getrandmax from "./components/PHP_mt_getrandmax";
import PHP_mt_rand from "./components/PHP_mt_rand";
import PHP_mt_srand from "./components/PHP_mt_srand";
import PHP_multi_query from "./components/PHP_multi_query";
import PHP_namespace from "./components/PHP_namespace";
import PHP_natcasesort from "./components/PHP_natcasesort";
import PHP_natsort from "./components/PHP_natsort";
import PHP_new from "./components/PHP_new";
import PHP_next from "./components/PHP_next";
import PHP_next_result from "./components/PHP_next_result";
import PHP_nl2br from "./components/PHP_nl2br";
import PHP_nl_langinfo from "./components/PHP_nl_langinfo";
import PHP_number_format from "./components/PHP_number_format";
import PHP_ob_clean from "./components/PHP_ob_clean";
import PHP_ob_end_clean from "./components/PHP_ob_end_clean";
import PHP_ob_end_flush from "./components/PHP_ob_end_flush";
import PHP_ob_flush from "./components/PHP_ob_flush";
import PHP_ob_get_clean from "./components/PHP_ob_get_clean";
import PHP_ob_get_contents from "./components/PHP_ob_get_contents";
import PHP_ob_get_flush from "./components/PHP_ob_get_flush";
import PHP_ob_get_length from "./components/PHP_ob_get_length";
import PHP_ob_get_level from "./components/PHP_ob_get_level";
import PHP_ob_gzhandler from "./components/PHP_ob_gzhandler";
import PHP_ob_implicit_flush from "./components/PHP_ob_implicit_flush";
import PHP_ob_list_handlers from "./components/PHP_ob_list_handlers";
import PHP_ob_start from "./components/PHP_ob_start";
import PHP_octdec from "./components/PHP_octdec";
import PHP_opendir from "./components/PHP_opendir";
import PHP_openlog from "./components/PHP_openlog";
import PHP_options from "./components/PHP_options";
import PHP_or from "./components/PHP_or";
import PHP_ord from "./components/PHP_ord";
import PHP_output_add_rewrite_var from "./components/PHP_output_add_rewrite_var";
import PHP_output_reset_rewrite_vars from "./components/PHP_output_reset_rewrite_vars";
import PHP_pack from "./components/PHP_pack";
import PHP_parse_ini_file from "./components/PHP_parse_ini_file";
import PHP_parse_ini_string from "./components/PHP_parse_ini_string";
import PHP_parse_str from "./components/PHP_parse_str";
import PHP_pathinfo from "./components/PHP_pathinfo";
import PHP_pclose from "./components/PHP_pclose";
import PHP_pfsockopen from "./components/PHP_pfsockopen";
import PHP_php_strip_whitespace from "./components/PHP_php_strip_whitespace";
import PHP_pi from "./components/PHP_pi";
import PHP_ping from "./components/PHP_ping";
import PHP_poll from "./components/PHP_poll";
import PHP_popen from "./components/PHP_popen";
import PHP_pos from "./components/PHP_pos";
import PHP_pow from "./components/PHP_pow";
import PHP_preg_filter from "./components/PHP_preg_filter";
import PHP_preg_grep from "./components/PHP_preg_grep";
import PHP_preg_last_error from "./components/PHP_preg_last_error";
import PHP_preg_match from "./components/PHP_preg_match";
import PHP_preg_match_all from "./components/PHP_preg_match_all";
import PHP_preg_quote from "./components/PHP_preg_quote";
import PHP_preg_replace from "./components/PHP_preg_replace";
import PHP_preg_replace_callback from "./components/PHP_preg_replace_callback";
import PHP_preg_replace_callback_array from "./components/PHP_preg_replace_callback_array";
import PHP_preg_split from "./components/PHP_preg_split";
import PHP_prepare from "./components/PHP_prepare";
import PHP_prev from "./components/PHP_prev";
import PHP_print from "./components/PHP_print";
import PHP_print_r from "./components/PHP_print_r";
import PHP_printf from "./components/PHP_printf";
import PHP_private from "./components/PHP_private";
import PHP_protected from "./components/PHP_protected";
import PHP_public from "./components/PHP_public";
import PHP_query from "./components/PHP_query";
import PHP_quoted_printable_decode from "./components/PHP_quoted_printable_decode";
import PHP_quoted_printable_encode from "./components/PHP_quoted_printable_encode";
import PHP_quotemeta from "./components/PHP_quotemeta";
import PHP_rad2deg from "./components/PHP_rad2deg";
import PHP_rand from "./components/PHP_rand";
import PHP_range from "./components/PHP_range";
import PHP_readdir from "./components/PHP_readdir";
import PHP_readfile from "./components/PHP_readfile";
import PHP_readlink from "./components/PHP_readlink";
import PHP_real_connect from "./components/PHP_real_connect";
import PHP_real_escape_string from "./components/PHP_real_escape_string";
import PHP_real_query from "./components/PHP_real_query";
import PHP_realpath from "./components/PHP_realpath";
import PHP_realpath_cache_get from "./components/PHP_realpath_cache_get";
import PHP_realpath_cache_size from "./components/PHP_realpath_cache_size";
import PHP_reap_async_query from "./components/PHP_reap_async_query";
import PHP_reference_Error from "./components/PHP_reference_Error";
import PHP_reference_chdir from "./components/PHP_reference_chdir";
import PHP_reference_checkdate from "./components/PHP_reference_checkdate";
import PHP_refresh from "./components/PHP_refresh";
import PHP_registerXPathNamespace from "./components/PHP_registerXPathNamespace";
import PHP_rename from "./components/PHP_rename";
import PHP_require from "./components/PHP_require";
import PHP_require_once from "./components/PHP_require_once";
import PHP_reset from "./components/PHP_reset";
import PHP_restore_error_handler from "./components/PHP_restore_error_handler";
import PHP_restore_exception_handler from "./components/PHP_restore_exception_handler";
import PHP_return from "./components/PHP_return";
import PHP_rewind from "./components/PHP_rewind";
import PHP_rewinddir from "./components/PHP_rewinddir";
import PHP_rmdir from "./components/PHP_rmdir";
import PHP_rollback from "./components/PHP_rollback";
import PHP_round from "./components/PHP_round";
import PHP_rsort from "./components/PHP_rsort";
import PHP_rtrim from "./components/PHP_rtrim";
import PHP_saveXML from "./components/PHP_saveXML";
import PHP_scandir from "./components/PHP_scandir";
import PHP_select_db from "./components/PHP_select_db";
import PHP_serialize from "./components/PHP_serialize";
import PHP_set_charset from "./components/PHP_set_charset";
import PHP_set_error_handler from "./components/PHP_set_error_handler";
import PHP_set_exception_handler from "./components/PHP_set_exception_handler";
import PHP_set_file_buffer from "./components/PHP_set_file_buffer";
import PHP_set_local_infile_handler from "./components/PHP_set_local_infile_handler";
import PHP_setcookie from "./components/PHP_setcookie";
import PHP_setlocale from "./components/PHP_setlocale";
import PHP_setrawcookie from "./components/PHP_setrawcookie";
import PHP_settype from "./components/PHP_settype";
import PHP_sha1 from "./components/PHP_sha1";
import PHP_sha1_file from "./components/PHP_sha1_file";
import PHP_show_source from "./components/PHP_show_source";
import PHP_shuffle from "./components/PHP_shuffle";
import PHP_similar_text from "./components/PHP_similar_text";
import PHP_simplexml_import_dom from "./components/PHP_simplexml_import_dom";
import PHP_simplexml_load_file from "./components/PHP_simplexml_load_file";
import PHP_simplexml_load_string from "./components/PHP_simplexml_load_string";
import PHP_sin from "./components/PHP_sin";
import PHP_sinh from "./components/PHP_sinh";
import PHP_sizeof from "./components/PHP_sizeof";
import PHP_sleep from "./components/PHP_sleep";
import PHP_socket_get_status from "./components/PHP_socket_get_status";
import PHP_socket_set_blocking from "./components/PHP_socket_set_blocking";
import PHP_socket_set_timeout from "./components/PHP_socket_set_timeout";
import PHP_sort from "./components/PHP_sort";
import PHP_soundex from "./components/PHP_soundex";
import PHP_sprintf from "./components/PHP_sprintf";
import PHP_sqlstate from "./components/PHP_sqlstate";
import PHP_sqrt from "./components/PHP_sqrt";
import PHP_srand from "./components/PHP_srand";
import PHP_sscanf from "./components/PHP_sscanf";
import PHP_ssl_set from "./components/PHP_ssl_set";
import PHP_stat from "./components/PHP_stat";
import PHP_static from "./components/PHP_static";
import PHP_stmt_init from "./components/PHP_stmt_init";
import PHP_str_getcsv from "./components/PHP_str_getcsv";
import PHP_str_ireplace from "./components/PHP_str_ireplace";
import PHP_str_pad from "./components/PHP_str_pad";
import PHP_str_repeat from "./components/PHP_str_repeat";
import PHP_str_replace from "./components/PHP_str_replace";
import PHP_str_rot13 from "./components/PHP_str_rot13";
import PHP_str_shuffle from "./components/PHP_str_shuffle";
import PHP_str_split from "./components/PHP_str_split";
import PHP_str_word_count from "./components/PHP_str_word_count";
import PHP_strcasecmp from "./components/PHP_strcasecmp";
import PHP_strchr from "./components/PHP_strchr";
import PHP_strcmp from "./components/PHP_strcmp";
import PHP_strcoll from "./components/PHP_strcoll";
import PHP_strcspn from "./components/PHP_strcspn";
import PHP_strftime from "./components/PHP_strftime";
import PHP_strip_tags from "./components/PHP_strip_tags";
import PHP_stripcslashes from "./components/PHP_stripcslashes";
import PHP_stripos from "./components/PHP_stripos";
import PHP_stripslashes from "./components/PHP_stripslashes";
import PHP_stristr from "./components/PHP_stristr";
import PHP_strlen from "./components/PHP_strlen";
import PHP_strnatcasecmp from "./components/PHP_strnatcasecmp";
import PHP_strnatcmp from "./components/PHP_strnatcmp";
import PHP_strncasecmp from "./components/PHP_strncasecmp";
import PHP_strncmp from "./components/PHP_strncmp";
import PHP_strpbrk from "./components/PHP_strpbrk";
import PHP_strpos from "./components/PHP_strpos";
import PHP_strptime from "./components/PHP_strptime";
import PHP_strrchr from "./components/PHP_strrchr";
import PHP_strrev from "./components/PHP_strrev";
import PHP_strripos from "./components/PHP_strripos";
import PHP_strrpos from "./components/PHP_strrpos";
import PHP_strspn from "./components/PHP_strspn";
import PHP_strstr from "./components/PHP_strstr";
import PHP_strtok from "./components/PHP_strtok";
import PHP_strtolower from "./components/PHP_strtolower";
import PHP_strtotime from "./components/PHP_strtotime";
import PHP_strtoupper from "./components/PHP_strtoupper";
import PHP_strtr from "./components/PHP_strtr";
import PHP_strval from "./components/PHP_strval";
import PHP_substr from "./components/PHP_substr";
import PHP_substr_compare from "./components/PHP_substr_compare";
import PHP_substr_count from "./components/PHP_substr_count";
import PHP_substr_replace from "./components/PHP_substr_replace";

import PHP_symlink from "./components/PHP_symlink";
import PHP_sys_getloadavg from "./components/PHP_sys_getloadavg";
import PHP_syslog from "./components/PHP_syslog";
import PHP_tan from "./components/PHP_tan";
import PHP_tanh from "./components/PHP_tanh";
import PHP_tempnam from "./components/PHP_tempnam";
import PHP_thread_id from "./components/PHP_thread_id";
import PHP_thread_safe from "./components/PHP_thread_safe";
import PHP_throw from "./components/PHP_throw";
import PHP_time from "./components/PHP_time";
import PHP_time_nanosleep from "./components/PHP_time_nanosleep";
import PHP_time_sleep_until from "./components/PHP_time_sleep_until";
import PHP_timezone_abbreviations_list from "./components/PHP_timezone_abbreviations_list";
import PHP_timezone_identifiers_list from "./components/PHP_timezone_identifiers_list";
import PHP_timezone_location_get from "./components/PHP_timezone_location_get";
import PHP_timezone_name_from_abbr from "./components/PHP_timezone_name_from_abbr";
import PHP_timezone_name_get from "./components/PHP_timezone_name_get";
import PHP_timezone_offset_get from "./components/PHP_timezone_offset_get";
import PHP_timezone_open from "./components/PHP_timezone_open";
import PHP_timezone_transitions_get from "./components/PHP_timezone_transitions_get";
import PHP_timezone_version_get from "./components/PHP_timezone_version_get";
import PHP_tmpfile from "./components/PHP_tmpfile";
import PHP_touch from "./components/PHP_touch";
import PHP_trait from "./components/PHP_trait";
import PHP_trigger_error from "./components/PHP_trigger_error";
import PHP_trim from "./components/PHP_trim";
import PHP_try from "./components/PHP_try";
import PHP_uasort from "./components/PHP_uasort";
import PHP_ucfirst from "./components/PHP_ucfirst";
import PHP_ucwords from "./components/PHP_ucwords";
import PHP_uksort from "./components/PHP_uksort";
import PHP_umask from "./components/PHP_umask";
import PHP_uniqid from "./components/PHP_uniqid";
import PHP_unixtojd from "./components/PHP_unixtojd";
import PHP_unlink from "./components/PHP_unlink";
import PHP_unpack from "./components/PHP_unpack";
import PHP_unserialize from "./components/PHP_unserialize";
import PHP_unset from "./components/PHP_unset";
import PHP_use from "./components/PHP_use";
import PHP_use_result from "./components/PHP_use_result";
import PHP_usleep from "./components/PHP_usleep";
import PHP_usort from "./components/PHP_usort";
import PHP_utf8_decode from "./components/PHP_utf8_decode";
import PHP_utf8_encode from "./components/PHP_utf8_encode";
import PHP_valid from "./components/PHP_valid";
import PHP_var from "./components/PHP_var";
import PHP_var_dump from "./components/PHP_var_dump";
import PHP_var_export from "./components/PHP_var_export";
import PHP_vfprintf from "./components/PHP_vfprintf";
import PHP_vprintf from "./components/PHP_vprintf";
import PHP_vsprintf from "./components/PHP_vsprintf";
import PHP_warning_count from "./components/PHP_warning_count";
import PHP_while from "./components/PHP_while";
import PHP_wordwrap from "./components/PHP_wordwrap";
import PHP_xml_error_string from "./components/PHP_xml_error_string";
import PHP_xml_get_current_byte_index from "./components/PHP_xml_get_current_byte_index";
import PHP_xml_get_current_column_number from "./components/PHP_xml_get_current_column_number";
import PHP_xml_get_current_line_number from "./components/PHP_xml_get_current_line_number";
import PHP_xml_get_error_code from "./components/PHP_xml_get_error_code";
import PHP_xml_parse from "./components/PHP_xml_parse";
import PHP_xml_parse_into_struct from "./components/PHP_xml_parse_into_struct";
import PHP_xml_parser_create from "./components/PHP_xml_parser_create";
import PHP_xml_parser_create_ns from "./components/PHP_xml_parser_create_ns";
import PHP_xml_parser_free from "./components/PHP_xml_parser_free";
import PHP_xml_parser_get_option from "./components/PHP_xml_parser_get_option";
import PHP_xml_parser_set_option from "./components/PHP_xml_parser_set_option";
import PHP_xml_set_character_data_handler from "./components/PHP_xml_set_character_data_handler";
import PHP_xml_set_default_handler from "./components/PHP_xml_set_default_handler";
import PHP_xml_set_element_handler from "./components/PHP_xml_set_element_handler";
import PHP_xml_set_end_namespace_decl_handler from "./components/PHP_xml_set_end_namespace_decl_handler";
import PHP_xml_set_external_entity_ref_handler from "./components/PHP_xml_set_external_entity_ref_handler";
import PHP_xml_set_notation_decl_handler from "./components/PHP_xml_set_notation_decl_handler";
import PHP_xml_set_object from "./components/PHP_xml_set_object";
import PHP_xml_set_processing_instruction_handler from "./components/PHP_xml_set_processing_instruction_handler";
import PHP_xml_set_start_namespace_decl_handler from "./components/PHP_xml_set_start_namespace_decl_handler";
import PHP_xml_set_unparsed_entity_decl_handler from "./components/PHP_xml_set_unparsed_entity_decl_handler";
import PHP_xor from "./components/PHP_xor";
import PHP_xpath from "./components/PHP_xpath";
import PHP_yield from "./components/PHP_yield";
import PHP_yield_from from "./components/PHP_yield_from";
import PHP_zip_close from "./components/PHP_zip_close";
import PHP_zip_entry_close from "./components/PHP_zip_entry_close";
import PHP_zip_entry_compressedsize from "./components/PHP_zip_entry_compressedsize";
import PHP_zip_entry_compressionmethod from "./components/PHP_zip_entry_compressionmethod";
import PHP_zip_entry_filesize from "./components/PHP_zip_entry_filesize";
import PHP_zip_entry_name from "./components/PHP_zip_entry_name";
import PHP_zip_entry_open from "./components/PHP_zip_entry_open";
import PHP_zip_entry_read from "./components/PHP_zip_entry_read";
import PHP_zip_open from "./components/PHP_zip_open";
import PHP_zip_read from "./components/PHP_zip_read";

const AllPHPComponents = {
  "<PHP />": PHP,
  "<PHP_AbstractClasses />": PHP_AbstractClasses,
  "<PHP_AccessModifiers />": PHP_AccessModifiers,
  "<PHP_Access_Array_Items />": PHP_Access_Array_Items,
  "<PHP_Add_Array_Items />": PHP_Add_Array_Items,
  "<PHP_AjaxDatabase />": PHP_AjaxDatabase,
  "<PHP_AjaxIntro />": PHP_AjaxIntro,
  "<PHP_AjaxLiveSearch />": PHP_AjaxLiveSearch,
  "<PHP_AjaxPHP />": PHP_AjaxPHP,
  "<PHP_AjaxPoll />": PHP_AjaxPoll,
  "<PHP_AjaxXML />": PHP_AjaxXML,
  "<PHP_Array_Functions />": PHP_Array_Functions,
  "<PHP_Arrays />": PHP_Arrays,
  "<PHP_Associative_Arrays />": PHP_Associative_Arrays,

  "<PHP_Calendar />": PHP_Calendar,
  "<PHP_CallbackFunctions />": PHP_CallbackFunctions,
  "<PHP_Casting />": PHP_Casting,
  "<PHP_Certificate />": PHP_Certificate,
  "<PHP_ClassesObjects />": PHP_ClassesObjects,
  "<PHP_Comments />": PHP_Comments,
  "<PHP_Compiler />": PHP_Compiler,
  "<PHP_Concatenate_Strings />": PHP_Concatenate_Strings,
  "<PHP_Constants />": PHP_Constants,
  "<PHP_Constructor />": PHP_Constructor,
  "<PHP_Switch />": PHP_Switch,

  "<PHP_Cookies />": PHP_Cookies,
  "<PHP_Create_Arrays />": PHP_Create_Arrays,
  "<PHP_DataTypes />": PHP_DataTypes,
  "<PHP_DateTime />": PHP_DateTime,
  "<PHP_Destructor />": PHP_Destructor,
  "<PHP_Do_While_Loop />": PHP_Do_While_Loop,
  "<PHP_EchoPrint />": PHP_EchoPrint,
  "<PHP_Escape_Characters />": PHP_Escape_Characters,
  "<PHP_Examples />": PHP_Examples,
  "<PHP_Exception />": PHP_Exception,
  "<PHP_Exception_Main />": PHP_Exception_Main,
  "<PHP_Exceptions />": PHP_Exceptions,
  "<PHP_Exercises />": PHP_Exercises,
  "<PHP_FileCreateWrite />": PHP_FileCreateWrite,
  "<PHP_FileHandling />": PHP_FileHandling,
  "<PHP_FileOpenRead />": PHP_FileOpenRead,
  "<PHP_FileUpload />": PHP_FileUpload,
  "<PHP_Filters />": PHP_Filters,
  "<PHP_FiltersAdvanced />": PHP_FiltersAdvanced,
  "<PHP_For_Loop />": PHP_For_Loop,
  "<PHP_Foreach_Loop />": PHP_Foreach_Loop,
  "<PHP_FormComplete />": PHP_FormComplete,
  "<PHP_FormHandling />": PHP_FormHandling,
  "<PHP_FormRequired />": PHP_FormRequired,
  "<PHP_FormUrlEmail />": PHP_FormUrlEmail,
  "<PHP_FormValidation />": PHP_FormValidation,
  "<PHP_Functions />": PHP_Functions,
  "<PHP_GET />": PHP_GET,
  "<PHP_GLOBALS />": PHP_GLOBALS,
  "<PHP_HOME />": PHP_HOME,
  "<PHP_If />": PHP_If,
  "<PHP_IfElse_Main />": PHP_IfElse_Main,
  "<PHP_If_Operators />": PHP_If_Operators,
  "<PHP_Include />": PHP_Include,
  "<PHP_Indexed_Arrays />": PHP_Indexed_Arrays,
  "<PHP_Inheritance />": PHP_Inheritance,
  "<PHP_Install />": PHP_Install,
  "<PHP_Interfaces />": PHP_Interfaces,
  "<PHP_Intro />": PHP_Intro,
  "<PHP_Iterables />": PHP_Iterables,
  "<PHP_JSON />": PHP_JSON,
  "<PHP_Loops />": PHP_Loops,
  "<PHP_MagicConstants />": PHP_MagicConstants,
  "<PHP_Math />": PHP_Math,
  "<PHP_Modify_Strings />": PHP_Modify_Strings,
  "<PHP_Multidimensional_Arrays />": PHP_Multidimensional_Arrays,
  "<PHP_Multiline_Comments />": PHP_Multiline_Comments,
  "<PHP_MySQLConnect />": PHP_MySQLConnect,
  "<PHP_MySQLCreateDB />": PHP_MySQLCreateDB,
  "<PHP_MySQLCreateTable />": PHP_MySQLCreateTable,
  "<PHP_MySQLDatabase />": PHP_MySQLDatabase,
  "<PHP_MySQLDelete />": PHP_MySQLDelete,
  "<PHP_MySQLInsert />": PHP_MySQLInsert,
  "<PHP_MySQLInsertMultiple />": PHP_MySQLInsertMultiple,
  "<PHP_MySQLLastID />": PHP_MySQLLastID,
  "<PHP_MySQLLimit />": PHP_MySQLLimit,
  "<PHP_MySQLOrderBy />": PHP_MySQLOrderBy,
  "<PHP_MySQLPrepared />": PHP_MySQLPrepared,
  "<PHP_MySQLSelect />": PHP_MySQLSelect,
  "<PHP_MySQLUpdate />": PHP_MySQLUpdate,
  "<PHP_MySQLWhere />": PHP_MySQLWhere,
  "<PHP_Namespaces />": PHP_Namespaces,
  "<PHP_Nested_If />": PHP_Nested_If,
  "<PHP_Numbers />": PHP_Numbers,
  "<PHP_OOPConstants />": PHP_OOPConstants,
  "<PHP_OOPIntro />": PHP_OOPIntro,
  "<PHP_Operators />": PHP_Operators,
  "<PHP_POST />": PHP_POST,
  "<PHP_Quiz />": PHP_Quiz,
  "<PHP_REQUEST />": PHP_REQUEST,
  "<PHP_RefArray />": PHP_RefArray,
  "<PHP_ReferenceArray />": PHP_ReferenceArray,
  "<PHP_ReferenceFTP />": PHP_ReferenceFTP,
  "<PHP_ReferenceFilesystem />": PHP_ReferenceFilesystem,
  "<PHP_ReferenceFilter />": PHP_ReferenceFilter,
  "<PHP_ReferenceJSON />": PHP_ReferenceJSON,
  "<PHP_ReferenceKeywords />": PHP_ReferenceKeywords,
  "<PHP_ReferenceLibxml />": PHP_ReferenceLibxml,
  "<PHP_ReferenceMail />": PHP_ReferenceMail,
  "<PHP_ReferenceMath />": PHP_ReferenceMath,
  "<PHP_ReferenceMisc />": PHP_ReferenceMisc,
  "<PHP_ReferenceMySQLi />": PHP_ReferenceMySQLi,
  "<PHP_ReferenceNetwork />": PHP_ReferenceNetwork,
  "<PHP_ReferenceOutputControl />": PHP_ReferenceOutputControl,
  "<PHP_ReferenceOverview />": PHP_ReferenceOverview,
  "<PHP_ReferenceRegEx />": PHP_ReferenceRegEx,
  "<PHP_ReferenceSimpleXML />": PHP_ReferenceSimpleXML,
  "<PHP_ReferenceStream />": PHP_ReferenceStream,
  "<PHP_ReferenceString />": PHP_ReferenceString,
  "<PHP_ReferenceTimezones />": PHP_ReferenceTimezones,
  "<PHP_ReferenceVariableHandling />": PHP_ReferenceVariableHandling,
  "<PHP_ReferenceXMLParser />": PHP_ReferenceXMLParser,
  "<PHP_ReferenceZip />": PHP_ReferenceZip,
  "<PHP_RegEx />": PHP_RegEx,
  "<PHP_Remove_Array_Items />": PHP_Remove_Array_Items,

  "<PHP_Sessions />": PHP_Sessions,
  "<PHP_Shorthand_If />": PHP_Shorthand_If,
  "<PHP_SimpleXMLGet />": PHP_SimpleXMLGet,
  "<PHP_SimpleXMLParser />": PHP_SimpleXMLParser,
  "<PHP_Slicing_Strings />": PHP_Slicing_Strings,
  "<PHP_Sorting_Arrays />": PHP_Sorting_Arrays,
  "<PHP_StaticMethods />": PHP_StaticMethods,
  "<PHP_StaticProperties />": PHP_StaticProperties,
  "<PHP_Strings />": PHP_Strings,
  "<PHP_StudyPlan />": PHP_StudyPlan,
  "<PHP_Superglobals />": PHP_Superglobals,

  "<PHP_Syllabus />": PHP_Syllabus,
  "<PHP_Syntax />": PHP_Syntax,
  "<PHP_Traits />": PHP_Traits,
  "<PHP_Update_Array_Items />": PHP_Update_Array_Items,
  "<PHP_Variables />": PHP_Variables,
  "<PHP_Variables_Main />": PHP_Variables_Main,
  "<PHP_Variables_Scope />": PHP_Variables_Scope,
  "<PHP_While_Loop />": PHP_While_Loop,
  "<PHP_XMLDOM />": PHP_XMLDOM,
  "<PHP_XMLExpat />": PHP_XMLExpat,
  "<PHP_XMLParsers />": PHP_XMLParsers,
  "<PHP___construct />": PHP___construct,
  "<PHP___halt_compiler />": PHP___halt_compiler,
  "<PHP___tostring />": PHP___tostring,
  "<PHP_abs />": PHP_abs,
  "<PHP_abstract />": PHP_abstract,
  "<PHP_acos />": PHP_acos,
  "<PHP_acosh />": PHP_acosh,
  "<PHP_addAttribute />": PHP_addAttribute,
  "<PHP_addChild />": PHP_addChild,
  "<PHP_addcslashes />": PHP_addcslashes,
  "<PHP_addslashes />": PHP_addslashes,
  "<PHP_affected_rows />": PHP_affected_rows,
  "<PHP_and />": PHP_and,
  "<PHP_array_change_key_case />": PHP_array_change_key_case,
  "<PHP_array_chunk />": PHP_array_chunk,
  "<PHP_array_column />": PHP_array_column,
  "<PHP_array_combine />": PHP_array_combine,
  "<PHP_array_count_values />": PHP_array_count_values,
  "<PHP_array_diff />": PHP_array_diff,
  "<PHP_array_diff_assoc />": PHP_array_diff_assoc,
  "<PHP_array_diff_key />": PHP_array_diff_key,
  "<PHP_array_diff_uassoc />": PHP_array_diff_uassoc,
  "<PHP_array_diff_ukey />": PHP_array_diff_ukey,
  "<PHP_array_fill />": PHP_array_fill,
  "<PHP_array_fill_keys />": PHP_array_fill_keys,
  "<PHP_array_filter />": PHP_array_filter,
  "<PHP_array_flip />": PHP_array_flip,
  "<PHP_array_intersect />": PHP_array_intersect,
  "<PHP_array_intersect_assoc />": PHP_array_intersect_assoc,
  "<PHP_array_intersect_key />": PHP_array_intersect_key,
  "<PHP_array_intersect_uassoc />": PHP_array_intersect_uassoc,
  "<PHP_array_intersect_ukey />": PHP_array_intersect_ukey,
  "<PHP_array_key_exists />": PHP_array_key_exists,
  "<PHP_array_keys />": PHP_array_keys,
  "<PHP_array_map />": PHP_array_map,
  "<PHP_array_merge />": PHP_array_merge,
  "<PHP_array_merge_recursive />": PHP_array_merge_recursive,
  "<PHP_array_multisort />": PHP_array_multisort,
  "<PHP_array_pad />": PHP_array_pad,
  "<PHP_array_pop />": PHP_array_pop,
  "<PHP_array_product />": PHP_array_product,
  "<PHP_array_push />": PHP_array_push,
  "<PHP_array_rand />": PHP_array_rand,
  "<PHP_array_reduce />": PHP_array_reduce,
  "<PHP_array_replace />": PHP_array_replace,
  "<PHP_array_replace_recursive />": PHP_array_replace_recursive,
  "<PHP_array_reverse />": PHP_array_reverse,
  "<PHP_array_search />": PHP_array_search,
  "<PHP_array_shift />": PHP_array_shift,
  "<PHP_array_slice />": PHP_array_slice,
  "<PHP_array_splice />": PHP_array_splice,
  "<PHP_array_sum />": PHP_array_sum,
  "<PHP_array_udiff />": PHP_array_udiff,
  "<PHP_array_udiff_assoc />": PHP_array_udiff_assoc,
  "<PHP_array_udiff_uassoc />": PHP_array_udiff_uassoc,
  "<PHP_array_uintersect />": PHP_array_uintersect,
  "<PHP_array_uintersect_assoc />": PHP_array_uintersect_assoc,
  "<PHP_array_uintersect_uassoc />": PHP_array_uintersect_uassoc,
  "<PHP_array_unique />": PHP_array_unique,
  "<PHP_array_unshift />": PHP_array_unshift,
  "<PHP_array_values />": PHP_array_values,
  "<PHP_array_walk />": PHP_array_walk,
  "<PHP_array_walk_recursive />": PHP_array_walk_recursive,
  "<PHP_arsort />": PHP_arsort,
  "<PHP_as />": PHP_as,
  "<PHP_asXML />": PHP_asXML,
  "<PHP_asin />": PHP_asin,
  "<PHP_asinh />": PHP_asinh,
  "<PHP_asort />": PHP_asort,
  "<PHP_atan />": PHP_atan,
  "<PHP_atan2 />": PHP_atan2,
  "<PHP_atanh />": PHP_atanh,
  "<PHP_attributes />": PHP_attributes,
  "<PHP_autocommit />": PHP_autocommit,
  "<PHP_base_convert />": PHP_base_convert,
  "<PHP_basename />": PHP_basename,
  "<PHP_bin2hex />": PHP_bin2hex,
  "<PHP_bindec />": PHP_bindec,
  "<PHP_boolval />": PHP_boolval,

  "<PHP_cal_days_in_month />": PHP_cal_days_in_month,
  "<PHP_cal_from_jd />": PHP_cal_from_jd,
  "<PHP_cal_info />": PHP_cal_info,
  "<PHP_cal_to_jd />": PHP_cal_to_jd,
  "<PHP_callable />": PHP_callable,
  "<PHP_case />": PHP_case,
  "<PHP_catch />": PHP_catch,
  "<PHP_ceil />": PHP_ceil,
  "<PHP_change_user />": PHP_change_user,
  "<PHP_character_set_name />": PHP_character_set_name,
  "<PHP_chdir />": PHP_chdir,
  "<PHP_checkdate />": PHP_checkdate,
  "<PHP_checkdnsrr />": PHP_checkdnsrr,
  "<PHP_chgrp />": PHP_chgrp,
  "<PHP_children />": PHP_children,
  "<PHP_chmod />": PHP_chmod,
  "<PHP_chop />": PHP_chop,
  "<PHP_chown />": PHP_chown,
  "<PHP_chr />": PHP_chr,
  "<PHP_chroot />": PHP_chroot,
  "<PHP_chunk_split />": PHP_chunk_split,
  "<PHP_class />": PHP_class,
  "<PHP_clearstatcache />": PHP_clearstatcache,
  "<PHP_clone />": PHP_clone,
  "<PHP_close />": PHP_close,
  "<PHP_closedir />": PHP_closedir,
  "<PHP_closelog />": PHP_closelog,
  "<PHP_commit />": PHP_commit,
  "<PHP_compact />": PHP_compact,
  "<PHP_connect />": PHP_connect,
  "<PHP_connect_errno />": PHP_connect_errno,
  "<PHP_connect_error />": PHP_connect_error,
  "<PHP_connection_aborted />": PHP_connection_aborted,
  "<PHP_connection_status />": PHP_connection_status,
  "<PHP_connection_timeout />": PHP_connection_timeout,
  "<PHP_const />": PHP_const,
  "<PHP_constant />": PHP_constant,

  "<PHP_convert_cyr_string />": PHP_convert_cyr_string,
  "<PHP_convert_uudecode />": PHP_convert_uudecode,
  "<PHP_convert_uuencode />": PHP_convert_uuencode,
  "<PHP_copy />": PHP_copy,
  "<PHP_cos />": PHP_cos,
  "<PHP_cosh />": PHP_cosh,
  "<PHP_count />": PHP_count,
  "<PHP_count_chars />": PHP_count_chars,
  "<PHP_crc32 />": PHP_crc32,
  "<PHP_crypt />": PHP_crypt,
  "<PHP_current />": PHP_current,
  "<PHP_data_seek />": PHP_data_seek,
  "<PHP_date />": PHP_date,
  "<PHP_date_add />": PHP_date_add,
  "<PHP_date_create />": PHP_date_create,
  "<PHP_date_create_from_format />": PHP_date_create_from_format,
  "<PHP_date_date_set />": PHP_date_date_set,
  "<PHP_date_default_timezone_get />": PHP_date_default_timezone_get,
  "<PHP_date_default_timezone_set />": PHP_date_default_timezone_set,
  "<PHP_date_diff />": PHP_date_diff,
  "<PHP_date_format />": PHP_date_format,
  "<PHP_date_get_last_errors />": PHP_date_get_last_errors,
  "<PHP_date_interval_create_from_date_string />":
    PHP_date_interval_create_from_date_string,
  "<PHP_date_interval_format />": PHP_date_interval_format,
  "<PHP_date_isodate_set />": PHP_date_isodate_set,
  "<PHP_date_modify />": PHP_date_modify,
  "<PHP_date_offset_get />": PHP_date_offset_get,
  "<PHP_date_parse />": PHP_date_parse,
  "<PHP_date_parse_from_format />": PHP_date_parse_from_format,
  "<PHP_date_sub />": PHP_date_sub,
  "<PHP_date_sun_info />": PHP_date_sun_info,
  "<PHP_date_sunrise />": PHP_date_sunrise,
  "<PHP_date_sunset />": PHP_date_sunset,
  "<PHP_date_time_set />": PHP_date_time_set,
  "<PHP_date_timestamp_get />": PHP_date_timestamp_get,
  "<PHP_date_timestamp_set />": PHP_date_timestamp_set,
  "<PHP_date_timezone_get />": PHP_date_timezone_get,
  "<PHP_date_timezone_set />": PHP_date_timezone_set,
  "<PHP_debug />": PHP_debug,
  "<PHP_debug_backtrace />": PHP_debug_backtrace,
  "<PHP_debug_print_backtrace />": PHP_debug_print_backtrace,
  "<PHP_debug_zval_dump />": PHP_debug_zval_dump,
  "<PHP_decbin />": PHP_decbin,
  "<PHP_dechex />": PHP_dechex,
  "<PHP_declare />": PHP_declare,
  "<PHP_decoct />": PHP_decoct,
  "<PHP_default />": PHP_default,
  "<PHP_define />": PHP_define,
  "<PHP_defined />": PHP_defined,
  "<PHP_deg2rad />": PHP_deg2rad,
  "<PHP_delete />": PHP_delete,
  "<PHP_die />": PHP_die,
  "<PHP_dir />": PHP_dir,
  "<PHP_dirname />": PHP_dirname,
  "<PHP_disk_free_space />": PHP_disk_free_space,
  "<PHP_disk_total_space />": PHP_disk_total_space,
  "<PHP_diskfreespace />": PHP_diskfreespace,
  "<PHP_dns_check_record />": PHP_dns_check_record,
  "<PHP_dns_get_mx />": PHP_dns_get_mx,
  "<PHP_dns_get_record />": PHP_dns_get_record,
  "<PHP_do />": PHP_do,
  "<PHP_doubleval />": PHP_doubleval,
  "<PHP_dump_debug_info />": PHP_dump_debug_info,
  "<PHP_each />": PHP_each,
  "<PHP_easter_date />": PHP_easter_date,
  "<PHP_easter_days />": PHP_easter_days,
  "<PHP_echo />": PHP_echo,
  "<PHP_else />": PHP_else,
  "<PHP_elseif />": PHP_elseif,
  "<PHP_empty />": PHP_empty,
  "<PHP_end />": PHP_end,
  "<PHP_enddeclare />": PHP_enddeclare,
  "<PHP_endfor />": PHP_endfor,
  "<PHP_endforeach />": PHP_endforeach,
  "<PHP_endif />": PHP_endif,
  "<PHP_endswitch />": PHP_endswitch,
  "<PHP_endwhile />": PHP_endwhile,
  "<PHP_errno />": PHP_errno,
  "<PHP_error />": PHP_error,
  "<PHP_error_get_last />": PHP_error_get_last,
  "<PHP_error_list />": PHP_error_list,
  "<PHP_error_log />": PHP_error_log,
  "<PHP_error_reporting />": PHP_error_reporting,
  "<PHP_eval />": PHP_eval,
  "<PHP_exit />": PHP_exit,
  "<PHP_exp />": PHP_exp,
  "<PHP_explode />": PHP_explode,
  "<PHP_expm1 />": PHP_expm1,
  "<PHP_extends />": PHP_extends,
  "<PHP_extract />": PHP_extract,
  "<PHP_ezmlm_hash />": PHP_ezmlm_hash,
  "<PHP_fclose />": PHP_fclose,
  "<PHP_feof />": PHP_feof,
  "<PHP_fetch_all />": PHP_fetch_all,
  "<PHP_fetch_array />": PHP_fetch_array,
  "<PHP_fetch_assoc />": PHP_fetch_assoc,
  "<PHP_fetch_field />": PHP_fetch_field,
  "<PHP_fetch_field_direct />": PHP_fetch_field_direct,
  "<PHP_fetch_fields />": PHP_fetch_fields,
  "<PHP_fetch_lengths />": PHP_fetch_lengths,
  "<PHP_fetch_object />": PHP_fetch_object,
  "<PHP_fetch_row />": PHP_fetch_row,
  "<PHP_fflush />": PHP_fflush,
  "<PHP_fgetc />": PHP_fgetc,
  "<PHP_fgetcsv />": PHP_fgetcsv,
  "<PHP_fgets />": PHP_fgets,
  "<PHP_fgetss />": PHP_fgetss,
  "<PHP_field_count />": PHP_field_count,
  "<PHP_field_seek />": PHP_field_seek,
  "<PHP_file />": PHP_file,
  "<PHP_file_exists />": PHP_file_exists,
  "<PHP_file_get_contents />": PHP_file_get_contents,
  "<PHP_file_put_contents />": PHP_file_put_contents,
  "<PHP_fileatime />": PHP_fileatime,
  "<PHP_filectime />": PHP_filectime,
  "<PHP_filegroup />": PHP_filegroup,
  "<PHP_fileinode />": PHP_fileinode,
  "<PHP_filemtime />": PHP_filemtime,
  "<PHP_fileowner />": PHP_fileowner,
  "<PHP_fileperms />": PHP_fileperms,
  "<PHP_filesize />": PHP_filesize,
  "<PHP_filetype />": PHP_filetype,
  "<PHP_filter_has_var />": PHP_filter_has_var,
  "<PHP_filter_id />": PHP_filter_id,
  "<PHP_filter_input />": PHP_filter_input,
  "<PHP_filter_input_array />": PHP_filter_input_array,
  "<PHP_filter_list />": PHP_filter_list,
  "<PHP_filter_var />": PHP_filter_var,
  "<PHP_filter_var_array />": PHP_filter_var_array,
  "<PHP_final />": PHP_final,
  "<PHP_finally />": PHP_finally,
  "<PHP_floatval />": PHP_floatval,
  "<PHP_flock />": PHP_flock,
  "<PHP_floor />": PHP_floor,
  "<PHP_flush />": PHP_flush,
  "<PHP_fmod />": PHP_fmod,
  "<PHP_fn />": PHP_fn,
  "<PHP_fnmatch />": PHP_fnmatch,
  "<PHP_fopen />": PHP_fopen,
  "<PHP_for />": PHP_for,
  "<PHP_foreach />": PHP_foreach,
  "<PHP_fpassthru />": PHP_fpassthru,
  "<PHP_fprint />": PHP_fprint,
  "<PHP_fputcsv />": PHP_fputcsv,
  "<PHP_fputs />": PHP_fputs,
  "<PHP_fread />": PHP_fread,
  "<PHP_frenchtojd />": PHP_frenchtojd,
  "<PHP_fscanf />": PHP_fscanf,
  "<PHP_fseek />": PHP_fseek,
  "<PHP_fsockopen />": PHP_fsockopen,
  "<PHP_fstat />": PHP_fstat,
  "<PHP_ftell />": PHP_ftell,
  "<PHP_ftp_alloc />": PHP_ftp_alloc,
  "<PHP_ftp_cdup />": PHP_ftp_cdup,
  "<PHP_ftp_chdir />": PHP_ftp_chdir,
  "<PHP_ftp_chmod />": PHP_ftp_chmod,
  "<PHP_ftp_close />": PHP_ftp_close,
  "<PHP_ftp_connect />": PHP_ftp_connect,
  "<PHP_ftp_delete />": PHP_ftp_delete,
  "<PHP_ftp_exec />": PHP_ftp_exec,
  "<PHP_ftp_fget />": PHP_ftp_fget,
  "<PHP_ftp_fput />": PHP_ftp_fput,
  "<PHP_ftp_get />": PHP_ftp_get,
  "<PHP_ftp_get_option />": PHP_ftp_get_option,
  "<PHP_ftp_login />": PHP_ftp_login,
  "<PHP_ftp_mdtm />": PHP_ftp_mdtm,
  "<PHP_ftp_mkdir />": PHP_ftp_mkdir,
  "<PHP_ftp_mlsd />": PHP_ftp_mlsd,
  "<PHP_ftp_nb_continue />": PHP_ftp_nb_continue,
  "<PHP_ftp_nb_fget />": PHP_ftp_nb_fget,
  "<PHP_ftp_nb_fput />": PHP_ftp_nb_fput,
  "<PHP_ftp_nb_get />": PHP_ftp_nb_get,
  "<PHP_ftp_nb_put />": PHP_ftp_nb_put,
  "<PHP_ftp_nlist />": PHP_ftp_nlist,
  "<PHP_ftp_pasv />": PHP_ftp_pasv,
  "<PHP_ftp_put />": PHP_ftp_put,
  "<PHP_ftp_pwd />": PHP_ftp_pwd,
  "<PHP_ftp_quit />": PHP_ftp_quit,
  "<PHP_ftp_raw />": PHP_ftp_raw,
  "<PHP_ftp_rawlist />": PHP_ftp_rawlist,
  "<PHP_ftp_rename />": PHP_ftp_rename,
  "<PHP_ftp_rmdir />": PHP_ftp_rmdir,
  "<PHP_ftp_set_option />": PHP_ftp_set_option,
  "<PHP_ftp_site />": PHP_ftp_site,
  "<PHP_ftp_size />": PHP_ftp_size,
  "<PHP_ftp_ssl_connect />": PHP_ftp_ssl_connect,
  "<PHP_ftp_systype />": PHP_ftp_systype,
  "<PHP_ftruncate />": PHP_ftruncate,
  "<PHP_function />": PHP_function,
  "<PHP_fwrite />": PHP_fwrite,
  "<PHP_getCode />": PHP_getCode,
  "<PHP_getDocNamespaces />": PHP_getDocNamespaces,
  "<PHP_getFile />": PHP_getFile,
  "<PHP_getLine />": PHP_getLine,
  "<PHP_getMessage />": PHP_getMessage,
  "<PHP_getName />": PHP_getName,
  "<PHP_getNamespaces />": PHP_getNamespaces,
  "<PHP_getPrevious />": PHP_getPrevious,
  "<PHP_getTrace />": PHP_getTrace,
  "<PHP_getTraceAsString />": PHP_getTraceAsString,
  "<PHP_get_browser />": PHP_get_browser,
  "<PHP_get_charset />": PHP_get_charset,
  "<PHP_get_client_info />": PHP_get_client_info,
  "<PHP_get_client_stats />": PHP_get_client_stats,
  "<PHP_get_client_version />": PHP_get_client_version,
  "<PHP_get_connection_stats />": PHP_get_connection_stats,
  "<PHP_get_defined_vars />": PHP_get_defined_vars,
  "<PHP_get_host_info />": PHP_get_host_info,
  "<PHP_get_html_translation_table />": PHP_get_html_translation_table,
  "<PHP_get_proto_info />": PHP_get_proto_info,
  "<PHP_get_resource_type />": PHP_get_resource_type,
  "<PHP_get_server_info />": PHP_get_server_info,
  "<PHP_get_server_version />": PHP_get_server_version,
  "<PHP_getchildren />": PHP_getchildren,
  "<PHP_getcwd />": PHP_getcwd,
  "<PHP_getdate />": PHP_getdate,
  "<PHP_gethostbyaddr />": PHP_gethostbyaddr,
  "<PHP_gethostbyname />": PHP_gethostbyname,
  "<PHP_gethostbynamel />": PHP_gethostbynamel,
  "<PHP_gethostname />": PHP_gethostname,
  "<PHP_getmxrr />": PHP_getmxrr,
  "<PHP_getprotobyname />": PHP_getprotobyname,
  "<PHP_getprotobynumber />": PHP_getprotobynumber,
  "<PHP_getrandmax />": PHP_getrandmax,
  "<PHP_getservbyname />": PHP_getservbyname,
  "<PHP_getservbyport />": PHP_getservbyport,
  "<PHP_gettimeofday />": PHP_gettimeofday,
  "<PHP_gettype />": PHP_gettype,
  "<PHP_glob />": PHP_glob,
  "<PHP_global />": PHP_global,
  "<PHP_gmdate />": PHP_gmdate,
  "<PHP_gmmktime />": PHP_gmmktime,
  "<PHP_gmstrftime />": PHP_gmstrftime,
  "<PHP_gregoriantojd />": PHP_gregoriantojd,
  "<PHP_haschildren />": PHP_haschildren,
  "<PHP_header />": PHP_header,
  "<PHP_header_register_callback />": PHP_header_register_callback,
  "<PHP_header_remove />": PHP_header_remove,
  "<PHP_headers_list />": PHP_headers_list,
  "<PHP_headers_sent />": PHP_headers_sent,
  "<PHP_hebrev />": PHP_hebrev,
  "<PHP_hebrevc />": PHP_hebrevc,
  "<PHP_hex2bin />": PHP_hex2bin,
  "<PHP_hexdec />": PHP_hexdec,
  "<PHP_highlight_file />": PHP_highlight_file,
  "<PHP_highlight_string />": PHP_highlight_string,
  "<PHP_hrtime />": PHP_hrtime,
  "<PHP_html_entity_decode />": PHP_html_entity_decode,
  "<PHP_htmlentities />": PHP_htmlentities,
  "<PHP_htmlspecialchars />": PHP_htmlspecialchars,
  "<PHP_htmlspecialchars_decode />": PHP_htmlspecialchars_decode,
  "<PHP_http_response_code />": PHP_http_response_code,
  "<PHP_hypot />": PHP_hypot,
  "<PHP_idate />": PHP_idate,

  "<PHP_ignore_user_abort />": PHP_ignore_user_abort,
  "<PHP_implements />": PHP_implements,
  "<PHP_implode />": PHP_implode,
  "<PHP_in_array />": PHP_in_array,

  "<PHP_include_once />": PHP_include_once,
  "<PHP_inet_ntop />": PHP_inet_ntop,
  "<PHP_inet_pton />": PHP_inet_pton,
  "<PHP_info />": PHP_info,
  "<PHP_init />": PHP_init,
  "<PHP_insert_id />": PHP_insert_id,
  "<PHP_instanceof />": PHP_instanceof,
  "<PHP_insteadof />": PHP_insteadof,
  "<PHP_intdiv />": PHP_intdiv,
  "<PHP_interface />": PHP_interface,
  "<PHP_intval />": PHP_intval,
  "<PHP_ip2long />": PHP_ip2long,
  "<PHP_is_array />": PHP_is_array,
  "<PHP_is_bool />": PHP_is_bool,
  "<PHP_is_callable />": PHP_is_callable,
  "<PHP_is_countable />": PHP_is_countable,
  "<PHP_is_dir />": PHP_is_dir,
  "<PHP_is_double />": PHP_is_double,
  "<PHP_is_executable />": PHP_is_executable,
  "<PHP_is_file />": PHP_is_file,
  "<PHP_is_finite />": PHP_is_finite,
  "<PHP_is_float />": PHP_is_float,
  "<PHP_is_infinite />": PHP_is_infinite,
  "<PHP_is_int />": PHP_is_int,
  "<PHP_is_integer />": PHP_is_integer,
  "<PHP_is_iterable />": PHP_is_iterable,
  "<PHP_is_link />": PHP_is_link,
  "<PHP_is_long />": PHP_is_long,
  "<PHP_is_nan />": PHP_is_nan,
  "<PHP_is_null />": PHP_is_null,
  "<PHP_is_numeric />": PHP_is_numeric,
  "<PHP_is_object />": PHP_is_object,
  "<PHP_is_readable />": PHP_is_readable,
  "<PHP_is_real />": PHP_is_real,
  "<PHP_is_resource />": PHP_is_resource,
  "<PHP_is_scalar />": PHP_is_scalar,
  "<PHP_is_string />": PHP_is_string,
  "<PHP_is_uploaded_file />": PHP_is_uploaded_file,
  "<PHP_is_writable />": PHP_is_writable,
  "<PHP_is_writeable />": PHP_is_writeable,
  "<PHP_isset />": PHP_isset,
  "<PHP_jddayofweek />": PHP_jddayofweek,
  "<PHP_jdmonthname />": PHP_jdmonthname,
  "<PHP_jdtofrench />": PHP_jdtofrench,
  "<PHP_jdtogregorian />": PHP_jdtogregorian,
  "<PHP_jdtojewish />": PHP_jdtojewish,
  "<PHP_jdtojulian />": PHP_jdtojulian,
  "<PHP_jdtounix />": PHP_jdtounix,
  "<PHP_jewishtojd />": PHP_jewishtojd,
  "<PHP_join />": PHP_join,
  "<PHP_json_decode />": PHP_json_decode,
  "<PHP_json_encode />": PHP_json_encode,
  "<PHP_juliantojd />": PHP_juliantojd,
  "<PHP_key />": PHP_key,
  "<PHP_kill />": PHP_kill,
  "<PHP_krsort />": PHP_krsort,
  "<PHP_ksort />": PHP_ksort,
  "<PHP_lcfirst />": PHP_lcfirst,
  "<PHP_lcg_value />": PHP_lcg_value,
  "<PHP_lchgrp />": PHP_lchgrp,
  "<PHP_lchown />": PHP_lchown,
  "<PHP_levenshtein />": PHP_levenshtein,
  "<PHP_libxml_clear_errors />": PHP_libxml_clear_errors,
  "<PHP_libxml_disable_entity_loader />": PHP_libxml_disable_entity_loader,
  "<PHP_libxml_get_errors />": PHP_libxml_get_errors,
  "<PHP_libxml_get_last_error />": PHP_libxml_get_last_error,
  "<PHP_libxml_set_external_entity_loader />":
    PHP_libxml_set_external_entity_loader,
  "<PHP_libxml_set_streams_context />": PHP_libxml_set_streams_context,
  "<PHP_libxml_use_internal_errors />": PHP_libxml_use_internal_errors,
  "<PHP_link />": PHP_link,
  "<PHP_linkinfo />": PHP_linkinfo,
  "<PHP_list />": PHP_list,
  "<PHP_localeconv />": PHP_localeconv,
  "<PHP_localtime />": PHP_localtime,
  "<PHP_log />": PHP_log,
  "<PHP_log10 />": PHP_log10,
  "<PHP_log1p />": PHP_log1p,
  "<PHP_long2ip />": PHP_long2ip,
  "<PHP_lstat />": PHP_lstat,
  "<PHP_ltrim />": PHP_ltrim,
  "<PHP_mail />": PHP_mail,
  "<PHP_max />": PHP_max,
  "<PHP_md5 />": PHP_md5,
  "<PHP_md5_file />": PHP_md5_file,
  "<PHP_metaphone />": PHP_metaphone,
  "<PHP_microtime />": PHP_microtime,
  "<PHP_min />": PHP_min,
  "<PHP_mkdir />": PHP_mkdir,
  "<PHP_mktime />": PHP_mktime,
  "<PHP_money_format />": PHP_money_format,
  "<PHP_more_results />": PHP_more_results,
  "<PHP_move_uploaded_file />": PHP_move_uploaded_file,
  "<PHP_mt_getrandmax />": PHP_mt_getrandmax,
  "<PHP_mt_rand />": PHP_mt_rand,
  "<PHP_mt_srand />": PHP_mt_srand,
  "<PHP_multi_query />": PHP_multi_query,
  "<PHP_namespace />": PHP_namespace,
  "<PHP_natcasesort />": PHP_natcasesort,
  "<PHP_natsort />": PHP_natsort,
  "<PHP_new />": PHP_new,
  "<PHP_next />": PHP_next,
  "<PHP_next_result />": PHP_next_result,
  "<PHP_nl2br />": PHP_nl2br,
  "<PHP_nl_langinfo />": PHP_nl_langinfo,
  "<PHP_number_format />": PHP_number_format,
  "<PHP_ob_clean />": PHP_ob_clean,
  "<PHP_ob_end_clean />": PHP_ob_end_clean,
  "<PHP_ob_end_flush />": PHP_ob_end_flush,
  "<PHP_ob_flush />": PHP_ob_flush,
  "<PHP_ob_get_clean />": PHP_ob_get_clean,
  "<PHP_ob_get_contents />": PHP_ob_get_contents,
  "<PHP_ob_get_flush />": PHP_ob_get_flush,
  "<PHP_ob_get_length />": PHP_ob_get_length,
  "<PHP_ob_get_level />": PHP_ob_get_level,
  "<PHP_ob_gzhandler />": PHP_ob_gzhandler,
  "<PHP_ob_implicit_flush />": PHP_ob_implicit_flush,
  "<PHP_ob_list_handlers />": PHP_ob_list_handlers,
  "<PHP_ob_start />": PHP_ob_start,
  "<PHP_octdec />": PHP_octdec,
  "<PHP_opendir />": PHP_opendir,
  "<PHP_openlog />": PHP_openlog,
  "<PHP_options />": PHP_options,
  "<PHP_or />": PHP_or,
  "<PHP_ord />": PHP_ord,
  "<PHP_output_add_rewrite_var />": PHP_output_add_rewrite_var,
  "<PHP_output_reset_rewrite_vars />": PHP_output_reset_rewrite_vars,
  "<PHP_pack />": PHP_pack,
  "<PHP_parse_ini_file />": PHP_parse_ini_file,
  "<PHP_parse_ini_string />": PHP_parse_ini_string,
  "<PHP_parse_str />": PHP_parse_str,
  "<PHP_pathinfo />": PHP_pathinfo,
  "<PHP_pclose />": PHP_pclose,
  "<PHP_pfsockopen />": PHP_pfsockopen,
  "<PHP_php_strip_whitespace />": PHP_php_strip_whitespace,
  "<PHP_pi />": PHP_pi,
  "<PHP_ping />": PHP_ping,
  "<PHP_poll />": PHP_poll,
  "<PHP_popen />": PHP_popen,
  "<PHP_pos />": PHP_pos,
  "<PHP_pow />": PHP_pow,
  "<PHP_preg_filter />": PHP_preg_filter,
  "<PHP_preg_grep />": PHP_preg_grep,
  "<PHP_preg_last_error />": PHP_preg_last_error,
  "<PHP_preg_match />": PHP_preg_match,
  "<PHP_preg_match_all />": PHP_preg_match_all,
  "<PHP_preg_quote />": PHP_preg_quote,
  "<PHP_preg_replace />": PHP_preg_replace,
  "<PHP_preg_replace_callback />": PHP_preg_replace_callback,
  "<PHP_preg_replace_callback_array />": PHP_preg_replace_callback_array,
  "<PHP_preg_split />": PHP_preg_split,
  "<PHP_prepare />": PHP_prepare,
  "<PHP_prev />": PHP_prev,
  "<PHP_print />": PHP_print,
  "<PHP_print_r />": PHP_print_r,
  "<PHP_printf />": PHP_printf,
  "<PHP_private />": PHP_private,
  "<PHP_protected />": PHP_protected,
  "<PHP_public />": PHP_public,
  "<PHP_query />": PHP_query,
  "<PHP_quoted_printable_decode />": PHP_quoted_printable_decode,
  "<PHP_quoted_printable_encode />": PHP_quoted_printable_encode,
  "<PHP_quotemeta />": PHP_quotemeta,
  "<PHP_rad2deg />": PHP_rad2deg,
  "<PHP_rand />": PHP_rand,
  "<PHP_range />": PHP_range,
  "<PHP_readdir />": PHP_readdir,
  "<PHP_readfile />": PHP_readfile,
  "<PHP_readlink />": PHP_readlink,
  "<PHP_real_connect />": PHP_real_connect,
  "<PHP_real_escape_string />": PHP_real_escape_string,
  "<PHP_real_query />": PHP_real_query,
  "<PHP_realpath />": PHP_realpath,
  "<PHP_realpath_cache_get />": PHP_realpath_cache_get,
  "<PHP_realpath_cache_size />": PHP_realpath_cache_size,
  "<PHP_reap_async_query />": PHP_reap_async_query,
  "<PHP_reference_Error />": PHP_reference_Error,
  "<PHP_reference_chdir />": PHP_reference_chdir,
  "<PHP_reference_checkdate />": PHP_reference_checkdate,
  "<PHP_refresh />": PHP_refresh,
  "<PHP_registerXPathNamespace />": PHP_registerXPathNamespace,
  "<PHP_rename />": PHP_rename,
  "<PHP_require />": PHP_require,
  "<PHP_require_once />": PHP_require_once,
  "<PHP_reset />": PHP_reset,
  "<PHP_restore_error_handler />": PHP_restore_error_handler,
  "<PHP_restore_exception_handler />": PHP_restore_exception_handler,
  "<PHP_return />": PHP_return,
  "<PHP_rewind />": PHP_rewind,
  "<PHP_rewinddir />": PHP_rewinddir,
  "<PHP_rmdir />": PHP_rmdir,
  "<PHP_rollback />": PHP_rollback,
  "<PHP_round />": PHP_round,
  "<PHP_rsort />": PHP_rsort,
  "<PHP_rtrim />": PHP_rtrim,
  "<PHP_saveXML />": PHP_saveXML,
  "<PHP_scandir />": PHP_scandir,
  "<PHP_select_db />": PHP_select_db,
  "<PHP_serialize />": PHP_serialize,
  "<PHP_set_charset />": PHP_set_charset,
  "<PHP_set_error_handler />": PHP_set_error_handler,
  "<PHP_set_exception_handler />": PHP_set_exception_handler,
  "<PHP_set_file_buffer />": PHP_set_file_buffer,
  "<PHP_set_local_infile_handler />": PHP_set_local_infile_handler,
  "<PHP_setcookie />": PHP_setcookie,
  "<PHP_setlocale />": PHP_setlocale,
  "<PHP_setrawcookie />": PHP_setrawcookie,
  "<PHP_settype />": PHP_settype,
  "<PHP_sha1 />": PHP_sha1,
  "<PHP_sha1_file />": PHP_sha1_file,
  "<PHP_show_source />": PHP_show_source,
  "<PHP_shuffle />": PHP_shuffle,
  "<PHP_similar_text />": PHP_similar_text,
  "<PHP_simplexml_import_dom />": PHP_simplexml_import_dom,
  "<PHP_simplexml_load_file />": PHP_simplexml_load_file,
  "<PHP_simplexml_load_string />": PHP_simplexml_load_string,
  "<PHP_sin />": PHP_sin,
  "<PHP_sinh />": PHP_sinh,
  "<PHP_sizeof />": PHP_sizeof,
  "<PHP_sleep />": PHP_sleep,
  "<PHP_socket_get_status />": PHP_socket_get_status,
  "<PHP_socket_set_blocking />": PHP_socket_set_blocking,
  "<PHP_socket_set_timeout />": PHP_socket_set_timeout,
  "<PHP_sort />": PHP_sort,
  "<PHP_soundex />": PHP_soundex,
  "<PHP_sprintf />": PHP_sprintf,
  "<PHP_sqlstate />": PHP_sqlstate,
  "<PHP_sqrt />": PHP_sqrt,
  "<PHP_srand />": PHP_srand,
  "<PHP_sscanf />": PHP_sscanf,
  "<PHP_ssl_set />": PHP_ssl_set,
  "<PHP_stat />": PHP_stat,
  "<PHP_static />": PHP_static,
  "<PHP_stmt_init />": PHP_stmt_init,
  "<PHP_str_getcsv />": PHP_str_getcsv,
  "<PHP_str_ireplace />": PHP_str_ireplace,
  "<PHP_str_pad />": PHP_str_pad,
  "<PHP_str_repeat />": PHP_str_repeat,
  "<PHP_str_replace />": PHP_str_replace,
  "<PHP_str_rot13 />": PHP_str_rot13,
  "<PHP_str_shuffle />": PHP_str_shuffle,
  "<PHP_str_split />": PHP_str_split,
  "<PHP_str_word_count />": PHP_str_word_count,
  "<PHP_strcasecmp />": PHP_strcasecmp,
  "<PHP_strchr />": PHP_strchr,
  "<PHP_strcmp />": PHP_strcmp,
  "<PHP_strcoll />": PHP_strcoll,
  "<PHP_strcspn />": PHP_strcspn,
  "<PHP_strftime />": PHP_strftime,
  "<PHP_strip_tags />": PHP_strip_tags,
  "<PHP_stripcslashes />": PHP_stripcslashes,
  "<PHP_stripos />": PHP_stripos,
  "<PHP_stripslashes />": PHP_stripslashes,
  "<PHP_stristr />": PHP_stristr,
  "<PHP_strlen />": PHP_strlen,
  "<PHP_strnatcasecmp />": PHP_strnatcasecmp,
  "<PHP_strnatcmp />": PHP_strnatcmp,
  "<PHP_strncasecmp />": PHP_strncasecmp,
  "<PHP_strncmp />": PHP_strncmp,
  "<PHP_strpbrk />": PHP_strpbrk,
  "<PHP_strpos />": PHP_strpos,
  "<PHP_strptime />": PHP_strptime,
  "<PHP_strrchr />": PHP_strrchr,
  "<PHP_strrev />": PHP_strrev,
  "<PHP_strripos />": PHP_strripos,
  "<PHP_strrpos />": PHP_strrpos,
  "<PHP_strspn />": PHP_strspn,
  "<PHP_strstr />": PHP_strstr,
  "<PHP_strtok />": PHP_strtok,
  "<PHP_strtolower />": PHP_strtolower,
  "<PHP_strtotime />": PHP_strtotime,
  "<PHP_strtoupper />": PHP_strtoupper,
  "<PHP_strtr />": PHP_strtr,
  "<PHP_strval />": PHP_strval,
  "<PHP_substr />": PHP_substr,
  "<PHP_substr_compare />": PHP_substr_compare,
  "<PHP_substr_count />": PHP_substr_count,
  "<PHP_substr_replace />": PHP_substr_replace,

  "<PHP_symlink />": PHP_symlink,
  "<PHP_sys_getloadavg />": PHP_sys_getloadavg,
  "<PHP_syslog />": PHP_syslog,
  "<PHP_tan />": PHP_tan,
  "<PHP_tanh />": PHP_tanh,
  "<PHP_tempnam />": PHP_tempnam,
  "<PHP_thread_id />": PHP_thread_id,
  "<PHP_thread_safe />": PHP_thread_safe,
  "<PHP_throw />": PHP_throw,
  "<PHP_time />": PHP_time,
  "<PHP_time_nanosleep />": PHP_time_nanosleep,
  "<PHP_time_sleep_until />": PHP_time_sleep_until,
  "<PHP_timezone_abbreviations_list />": PHP_timezone_abbreviations_list,
  "<PHP_timezone_identifiers_list />": PHP_timezone_identifiers_list,
  "<PHP_timezone_location_get />": PHP_timezone_location_get,
  "<PHP_timezone_name_from_abbr />": PHP_timezone_name_from_abbr,
  "<PHP_timezone_name_get />": PHP_timezone_name_get,
  "<PHP_timezone_offset_get />": PHP_timezone_offset_get,
  "<PHP_timezone_open />": PHP_timezone_open,
  "<PHP_timezone_transitions_get />": PHP_timezone_transitions_get,
  "<PHP_timezone_version_get />": PHP_timezone_version_get,
  "<PHP_tmpfile />": PHP_tmpfile,
  "<PHP_touch />": PHP_touch,
  "<PHP_trait />": PHP_trait,
  "<PHP_trigger_error />": PHP_trigger_error,
  "<PHP_trim />": PHP_trim,
  "<PHP_try />": PHP_try,
  "<PHP_uasort />": PHP_uasort,
  "<PHP_ucfirst />": PHP_ucfirst,
  "<PHP_ucwords />": PHP_ucwords,
  "<PHP_uksort />": PHP_uksort,
  "<PHP_umask />": PHP_umask,
  "<PHP_uniqid />": PHP_uniqid,
  "<PHP_unixtojd />": PHP_unixtojd,
  "<PHP_unlink />": PHP_unlink,
  "<PHP_unpack />": PHP_unpack,
  "<PHP_unserialize />": PHP_unserialize,
  "<PHP_unset />": PHP_unset,
  "<PHP_use />": PHP_use,
  "<PHP_use_result />": PHP_use_result,
  "<PHP_usleep />": PHP_usleep,
  "<PHP_usort />": PHP_usort,
  "<PHP_utf8_decode />": PHP_utf8_decode,
  "<PHP_utf8_encode />": PHP_utf8_encode,
  "<PHP_valid />": PHP_valid,
  "<PHP_var />": PHP_var,
  "<PHP_var_dump />": PHP_var_dump,
  "<PHP_var_export />": PHP_var_export,
  "<PHP_vfprintf />": PHP_vfprintf,
  "<PHP_vprintf />": PHP_vprintf,
  "<PHP_vsprintf />": PHP_vsprintf,
  "<PHP_warning_count />": PHP_warning_count,
  "<PHP_while />": PHP_while,
  "<PHP_wordwrap />": PHP_wordwrap,
  "<PHP_xml_error_string />": PHP_xml_error_string,
  "<PHP_xml_get_current_byte_index />": PHP_xml_get_current_byte_index,
  "<PHP_xml_get_current_column_number />": PHP_xml_get_current_column_number,
  "<PHP_xml_get_current_line_number />": PHP_xml_get_current_line_number,
  "<PHP_xml_get_error_code />": PHP_xml_get_error_code,
  "<PHP_xml_parse />": PHP_xml_parse,
  "<PHP_xml_parse_into_struct />": PHP_xml_parse_into_struct,
  "<PHP_xml_parser_create />": PHP_xml_parser_create,
  "<PHP_xml_parser_create_ns />": PHP_xml_parser_create_ns,
  "<PHP_xml_parser_free />": PHP_xml_parser_free,
  "<PHP_xml_parser_get_option />": PHP_xml_parser_get_option,
  "<PHP_xml_parser_set_option />": PHP_xml_parser_set_option,
  "<PHP_xml_set_character_data_handler />": PHP_xml_set_character_data_handler,
  "<PHP_xml_set_default_handler />": PHP_xml_set_default_handler,
  "<PHP_xml_set_element_handler />": PHP_xml_set_element_handler,
  "<PHP_xml_set_end_namespace_decl_handler />":
    PHP_xml_set_end_namespace_decl_handler,
  "<PHP_xml_set_external_entity_ref_handler />":
    PHP_xml_set_external_entity_ref_handler,
  "<PHP_xml_set_notation_decl_handler />": PHP_xml_set_notation_decl_handler,
  "<PHP_xml_set_object />": PHP_xml_set_object,
  "<PHP_xml_set_processing_instruction_handler />":
    PHP_xml_set_processing_instruction_handler,
  "<PHP_xml_set_start_namespace_decl_handler />":
    PHP_xml_set_start_namespace_decl_handler,
  "<PHP_xml_set_unparsed_entity_decl_handler />":
    PHP_xml_set_unparsed_entity_decl_handler,
  "<PHP_xor />": PHP_xor,
  "<PHP_xpath />": PHP_xpath,
  "<PHP_yield />": PHP_yield,
  "<PHP_yield_from />": PHP_yield_from,
  "<PHP_zip_close />": PHP_zip_close,
  "<PHP_zip_entry_close />": PHP_zip_entry_close,
  "<PHP_zip_entry_compressedsize />": PHP_zip_entry_compressedsize,
  "<PHP_zip_entry_compressionmethod />": PHP_zip_entry_compressionmethod,
  "<PHP_zip_entry_filesize />": PHP_zip_entry_filesize,
  "<PHP_zip_entry_name />": PHP_zip_entry_name,
  "<PHP_zip_entry_open />": PHP_zip_entry_open,
  "<PHP_zip_entry_read />": PHP_zip_entry_read,
  "<PHP_zip_open />": PHP_zip_open,
  "<PHP_zip_read />": PHP_zip_read,
};

export default AllPHPComponents;
